<template>
  <v-container fluid class="pa-8">
    <h2 class="text-h4 font-weight-bold mb-6">
      New/Edit Trademark Docket
    </h2>
    <!-- <v-card color="#FAFAFA"> -->
    <div class="pl-4 pr-4">
      <v-tabs
        v-model="tabselect"
        color="#55638E"
        class="custom-tabs"
        style="border-bottom: 1px solid #E0E0E0;"
      >
        <v-tab>Internal Work</v-tab>
        <v-tab>Internal Timeline</v-tab>
      </v-tabs>
    </div>

    <div v-if="tabselect == 0" class="mt-4 pl-4 pr-4">
      <v-card class="pa-10">
        <v-row class="pt-3">
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Object Type</h3>
            <v-autocomplete
              v-model="showaddItem.objecttype"
              :items="objecttype_list"
              item-text="objecttype_code"
              item-value="objecttype_id"
              outlined
              dense
              @change="objecttypeSelect"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Work Type</h3>
            <v-autocomplete
              v-model="showaddItem.doctype"
              :items="documenttype_list"
              item-text="documenttype_code"
              item-value="documenttype_id"
              outlined
              dense
              @input="
                () => {
                  if (showaddItem.refno == '' || showaddItem.refno == null) {
                    $nextTick(() => {
                      showaddItem.doctype = 0;
                    });
                    $store.state.global_dialog = true;
                    setupAlertDialog(
                      true,
                      'Check data',
                      'Put File NO',
                      'text-h5 red--text text-center',
                    );
                    return;
                  }
                  // calDateFinalDeadline();
                  checktypeFunction();
                }
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>File No.</h3>
            <v-text-field
              class="widthsizesearch heightsizesearch"
              outlined
              dense
              v-on:keyup.enter="onSearchfile_no(showaddItem.refno)"
              @blur="onSearchfile_no(showaddItem.refno)"
              v-model="showaddItem.refno"
            ></v-text-field>
            <h4 class="red--text">* input text and enter for search</h4>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Application No.</h3>
            <v-text-field
              v-model="app_noshow"
              disabled
              background-color="#F5F5F5"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mth">
          <v-col cols="12" sm="3" md="3">
            <h3>Client Name</h3>
            <v-textarea
              v-model="showaddItem.owner_name"
              outlined
              dense
              disabled
              auto-grow
              rows="1"
              class="no-resize-textarea"
              background-color="#F5F5F5"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Agent Name</h3>
            <v-text-field
              v-model="agent_contact_name"
              outlined
              dense
              disabled
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Associate Name</h3>
            <v-text-field
              v-model="associate_contact_name"
              outlined
              dense
              disabled
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Doc Type</h3>
            <v-autocomplete
              class="wrap-chips"
              v-model="doctype_actions_select"
              :items="doctype_actions_tlist"
              item-text="name"
              item-value="id"
              multiple
              chips
              outlined
              dense
              clearable
              style="max-width: 100%"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-row align="start">
              <v-col cols="4" sm="4" md="4">
                <h3
                  v-if="
                    showaddItem.doctype == 701 || showaddItem.doctype == 702
                  "
                >
                  Upload Opposition Notice File(s)
                </h3>
                <h3
                  v-if="
                    showaddItem.doctype == 801 || showaddItem.doctype == 802
                  "
                >
                  Upload Cancellation Notice File(s)
                </h3>
                <h3 v-else>Upload Notice File(s)</h3>
                <input
                  type="file"
                  accept="application/pdf,image/png,image/jpeg"
                  multiple="multiple"
                  @change="previewMultiFile"
                  ref="noticefile"
                  style="display: none"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"
                  @click="$refs.noticefile.click()"
                  class="widthbtnnoticefile"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload</v-btn
                >
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-10">
                <div v-if="this.filenamenotice.length > 0">
                  <v-row
                    v-for="(item, index) in filenamenotice"
                    :key="index"
                    style="padding-left: 70px"
                  >
                    <span
                      @click="previewnoticefilepdf(index)"
                      class="file-link"
                    >
                      {{ item }}
                    </span>
                    <v-btn
                      icon
                      color="red"
                      @click="confirmdeletenoticefile(index)"
                      style="margin-top: -7px"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row align="start">
              <v-col cols="4" sm="4" md="4">
                <h3
                  v-if="
                    showaddItem.doctype != 701 &&
                      showaddItem.doctype != 702 &&
                      showaddItem.doctype != 801 &&
                      showaddItem.doctype != 802
                  "
                >
                  Upload Submitted File(s)
                </h3>
                <h3 v-else>Upload Counter Argument File(s)</h3>
                <input
                  type="file"
                  accept="application/pdf,image/png,image/jpeg"
                  multiple="multiple"
                  @change="previewMultiAttachFile"
                  ref="attachfile"
                  style="display: none"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"
                  @click="$refs.attachfile.click()"
                  class="widthbtnnoticefile"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload</v-btn
                >
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-10">
                <div v-if="this.image_listattach.length > 0">
                  <v-row
                    v-for="(item, index) in this.image_listattach"
                    :key="index"
                    style="padding-left: 70px"
                  >
                    <span @click="previewattachfile(index)" class="file-link">
                      {{ item.name }}
                    </span>
                    <v-btn
                      icon
                      color="red"
                      @click="confirmdeleteattachfile(index)"
                      style="margin-top: -7px"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row
              align="start"
              v-if="
                showaddItem.doctype != 901 &&
                  showaddItem.doctype != 601 &&
                  showaddItem.doctype != 701 &&
                  showaddItem.doctype != 702 &&
                  showaddItem.doctype != 801 &&
                  showaddItem.doctype != 802
              "
            >
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Receipt(s)</h3>
                <input
                  type="file"
                  accept="application/pdf,image/png,image/jpeg"
                  multiple="multiple"
                  @change="previewMultiReceipt"
                  ref="receipt"
                  style="display: none"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"
                  @click="$refs.receipt.click()"
                  class="widthbtnnoticefile"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload</v-btn
                >
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-10">
                <div v-if="this.image_listrecicpt.length > 0">
                  <v-row
                    v-for="(item, index) in this.image_listrecicpt"
                    :key="index"
                    style="padding-left: 70px"
                  >
                    <span @click="previewreceiptfile(index)" class="file-link">
                      {{ item.name }}
                    </span>
                    <v-btn
                      icon
                      color="red"
                      @click="confirmdeleteattreceipt(index)"
                      style="margin-top: -7px"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row align="start" v-if="goodServiceFile">
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Goods/Service(.csv)</h3>
                <input
                  type="file"
                  ref="file_good_service"
                  style="display: none"
                  accept=".csv,text/csv"
                  @change="uploadCSVFile($event)"
                />
                <v-btn
                  color="#254E58"
                  dark
                  block
                  @click="$refs.file_good_service.click()"
                >
                  <v-icon left>mdi-cloud-upload</v-icon> Upload
                </v-btn>
              </v-col>
              <v-col
                cols="8"
                sm="8"
                md="8"
                class="mt-6"
                style="padding-left: 70px"
              >
                <ul v-if="fileList_good_service.length">
                  <li v-for="(file, i) in fileList_good_service" :key="i">
                    <a
                      :href="fileUrl(file)"
                      :download="file.name"
                      class="word-link"
                      >{{ file.name }}</a
                    >
                    <v-btn
                      icon
                      small
                      color="red"
                      @click="removeFileGood('good_service', i)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </li>
                </ul>
              </v-col>
            </v-row>

            <v-row class="mb-5" align="start" v-if="softFile">
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Soft File(s)</h3>
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"
                  @click="openselectFileWorld()"
                  class="widthbtnnoticefile"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload</v-btn
                >
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-8">
                <v-row
                  v-for="(label, key) in checkboxFields"
                  :key="key"
                  v-if="checkboxes[key]"
                >
                  <v-col cols="4" sm="4" md="4" style="padding-left: 70px">
                    <h4>{{ label }}</h4>
                  </v-col>

                  <v-col cols="8" sm="8" md="8" class="d-flex align-start">
                    <h4 style="padding-right: 11px">:</h4>

                    <input
                      :ref="`fileInput_${key}`"
                      type="file"
                      multiple
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      style="display: none"
                      @change="handleFileUpload($event, key)"
                    />
                    <v-list dense class="mr-2">
                      <v-list-item
                        v-for="(file, index) in uploadedFiles[key]"
                        :key="index"
                        class="px-0"
                        style="margin-top: -17px; margin-bottom: -20px"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            style="color: #1d88ac; font-size: 14px"
                            >{{ file.name }}</v-list-item-title
                          >
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon
                            color="red"
                            small
                            style="cursor: pointer"
                            @click="removeFile(key, index)"
                          >
                            mdi-close
                          </v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>

                    <v-icon
                      width="15px"
                      class="bt-add"
                      style="cursor: pointer"
                      @click="triggerFileInput(key)"
                    >
                      mdi-plus
                    </v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          justify="space-around"
          class="heightsize90formadvance"
          align="end"
          v-if="
            showaddItem.doctype == 3 ||
              showaddItem.doctype == 106 ||
              showaddItem.doctype == 1008
          "
        >
          <v-col cols="12" sm="3" md="3">
            <h3>Renewal Received Date</h3>
            <v-menu
              v-model="menuRenewalReceive"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.date_of_renewal_receive"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_renewal_receive = parseDate(
                      showaddItem.date_of_renewal_receive,
                    )
                  "
                  @blur="
                    date_of_renewal_receive = parseDate(
                      showaddItem.date_of_renewal_receive,
                    )
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="date_of_renewal_receive"
                @input="menuRenewalReceive = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Renewal Filed Date</h3>
            <v-menu
              v-model="menuReceive"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.receive_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    receive_date = parseDate(showaddItem.receive_date)
                  "
                  @blur="receive_date = parseDate(showaddItem.receive_date)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="receive_date"
                @input="menuReceive = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Renewal Not Payable Before</h3>
            <v-menu
              v-model="menurenewal_filed"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.date_of_renewal_filed"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_renewal_filed = parseDate(
                      showaddItem.date_of_renewal_filed,
                    )
                  "
                  @blur="
                    date_of_renewal_filed = parseDate(
                      showaddItem.date_of_renewal_filed,
                    )
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="date_of_renewal_filed"
                @input="menurenewal_filed = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Next Renewal Date</h3>
            <v-menu
              v-model="menurenewal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.date_of_renewal"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_renewal = parseDate(showaddItem.date_of_renewal)
                  "
                  @blur="
                    date_of_renewal = parseDate(showaddItem.date_of_renewal)
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="date_of_renewal"
                @input="menurenewal = false"
              >
                ></v-date-picker
              >
            </v-menu>
          </v-col>
          <v-col cols="0" sm="3" md="3" />
        </v-row>
        <v-row
          class="mt-4"
          v-if="
            showaddItem.doctype == 7 ||
              showaddItem.doctype == 107 ||
              showaddItem.doctype == 1001
          "
        >
          <v-col cols="12" sm="4" md="3">
            <h3><span class="red--text">* </span>Application Date</h3>
            <v-menu
              v-model="menuReceive"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.receive_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    receive_date = parseDate(showaddItem.receive_date)
                  "
                  @blur="receive_date = parseDate(showaddItem.receive_date)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="receive_date"
                @input="menuReceive = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <h3><span class="red--text">* </span>Application No.</h3>
            <v-text-field
              v-model="showaddItem.app_no"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="mt-n6"
          v-if="
            showaddItem.doctype == 7 ||
              showaddItem.doctype == 107 ||
              showaddItem.doctype == 1001
          "
        >
          <v-col cols="12" sm="4" md="3">
            <h3>Priority Deadline</h3>
            <v-menu
              v-model="menuaddnewfilling"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.new_filling"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    new_filling = parseDate(showaddItem.new_filling)
                  "
                  @blur="new_filling = parseDate(showaddItem.new_filling)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="new_filling"
                @input="menuaddnewfilling = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <h3>Internal Deadline</h3>
            <v-menu
              v-model="menuDeadline"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.internaldate"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    internaldate = parseDate(showaddItem.internaldate)
                  "
                  @blur="internaldate = parseDate(showaddItem.internaldate)"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  append-icon="mdi-calendar"
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="internaldate"
                @input="menuDeadline = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row
          class="heightsize90formadvance"
          align="end"
          v-if="defaultCulDate"
        >
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Receive Date</h3>
            <v-menu
              v-model="menuReceive"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.receive_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    receive_date = parseDate(showaddItem.receive_date)
                  "
                  @blur="receive_date = parseDate(showaddItem.receive_date)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="receive_date"
                @input="
                  () => {
                    menuReceive = false;
                    calDateFinalDeadline();
                  }
                "
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Submit Date</h3>
            <v-menu
              v-model="menuFilling"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.filling_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    filling_date = parseDate(showaddItem.filling_date)
                  "
                  @blur="filling_date = parseDate(showaddItem.filling_date)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="filling_date"
                @input="menuFilling = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="3"
            md="3"
            v-if="
              showaddItem.doctype != 8 &&
                showaddItem.doctype != 109 &&
                showaddItem.doctype != 601 &&
                showaddItem.doctype != 901 &&
                showaddItem.doctype != 1010
            "
          >
            <v-row class="mb-n12 pl-5 pr-5">
              <v-radio-group
                v-if="
                  showaddItem.doctype == 2 ||
                    showaddItem.doctype == 111 ||
                    showaddItem.doctype == 701 ||
                    showaddItem.doctype == 802 ||
                    showaddItem.doctype == 1002
                "
                v-model="radioDateSelect"
                row
                @change="onRadioSelectedDateType"
                style="width: 100%"
              >
                <v-col cols="6" class="pa-0">
                  <div class="pl-5">
                    ({{
                      this.formatDate(
                        this.data_maserter_pt.date_of_application,
                      )
                    }})
                  </div>
                  <v-radio
                    label="Application Date"
                    value="application_date"
                  ></v-radio>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <div class="pl-5">({{ this.showaddItem.receive_date }})</div>
                  <v-radio label="Receive Date" value="receive_date"></v-radio>
                </v-col>
              </v-radio-group>
            </v-row>
            <v-row
              v-if="
                showaddItem.doctype == 2 ||
                  showaddItem.doctype == 111 ||
                  showaddItem.doctype == 9 ||
                  showaddItem.doctype == 110 ||
                  showaddItem.doctype == 1005 ||
                  showaddItem.doctype == 19 ||
                  showaddItem.doctype == 113 ||
                  showaddItem.doctype == 1006 ||
                  showaddItem.doctype == 701 ||
                  showaddItem.doctype == 702 ||
                  showaddItem.doctype == 801 ||
                  showaddItem.doctype == 802 ||
                  showaddItem.doctype == 1002
              "
              class="pl-5 pr-5"
            >
              <v-radio-group
                v-model="radioValue"
                row
                @change="onRadioSelected"
                :disabled="radioValueDisable"
                style="width: 100%"
              >
                <v-col cols="6" sm="6" class="pa-0">
                  <v-radio
                    label="+60 Days (Others)"
                    value="60"
                    class="radio-label"
                    dense
                  ></v-radio>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-radio
                    label="+90 Days (POA)"
                    value="90"
                    dense
                    class="radio-label"
                  ></v-radio>
                </v-col>
              </v-radio-group>
            </v-row>

            <h3><span class="red--text">* </span>Final Deadline</h3>
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.enddate"
                  @click:clear="
                    $nextTick(() => {
                      clearEndDate();
                    })
                  "
                  clearable
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="enddate = parseDate(showaddItem.enddate)"
                  @blur="enddate = parseDate(showaddItem.enddate)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="enddate"
                @input="
                  () => {
                    menuStart = false;
                    onDateSelected();
                  }
                "
              >
                ></v-date-picker
              >
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
            v-if="
              showaddItem.doctype != 8 &&
                showaddItem.doctype != 109 &&
                showaddItem.doctype != 601 &&
                showaddItem.doctype != 901 &&
                showaddItem.doctype != 1010 &&
                showaddItem.doctype != 312
            "
          >
            <h3>Fixed Internal Date</h3>
            <v-menu
              v-model="menuDeadline"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.internaldate"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    internaldate = parseDate(showaddItem.internaldate)
                  "
                  @blur="internaldate = parseDate(showaddItem.internaldate)"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  disabled
                  background-color="#F5F5F5"
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="internaldate"
                @input="menuDeadline = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="showaddItem.doctype == 312">
            <h3>Fixed Internal Date</h3>
            <v-menu
              v-model="menuDeadline"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="showaddItem.internaldate"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    internaldate = parseDate(showaddItem.internaldate)
                  "
                  @blur="internaldate = parseDate(showaddItem.internaldate)"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="internaldate"
                @input="menuDeadline = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3"></v-col>
        </v-row>
        <v-row class="mt-n6">
          <v-col cols="4" sm="3" md="3">
            <h3>Source Type</h3>
            <v-select
              v-model="showaddItem.sourcetype"
              clearable
              :items="sourcetypelist"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row
          v-if="
            showaddItem.doctype == 9 ||
              showaddItem.doctype == 110 ||
              showaddItem.doctype == 1005 ||
              showaddItem.doctype == 113 ||
              showaddItem.doctype == 1006 ||
              showaddItem.doctype == 19 ||
              showaddItem.doctype == 702
          "
          v-for="(box, index) in decisionBoxes"
          :key="index"
          class="mb-6"
        >
          <v-col cols="12" md="8">
            <div class="decision-box">
              <!-- Header -->
              <div class="box-header d-flex justify-space-between align-center">
                <h3>Upload Decision Document ({{ labels[index] }})</h3>
                <div>
                  <v-btn
                    icon
                    color="#2196F3"
                    v-if="index === decisionBoxes.length - 1 && index != 2"
                    @click="addBox(index)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="error"
                    v-if="index === decisionBoxes.length - 1"
                    @click="removeBox(index)"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- Upload -->
              <v-row class="mt-n7">
                <v-col cols="12" md="5" class="pr-8">
                  <v-btn
                    width="100%"
                    color="#254E58"
                    dark
                    @click="triggerUpload(index)"
                  >
                    <v-icon left>mdi-cloud-upload</v-icon>Upload
                  </v-btn>

                  <!-- Hidden file input -->
                  <input
                    type="file"
                    multiple
                    ref="fileInputs"
                    class="hidden-input"
                    accept="application/pdf"
                    @change="onFilesSelected(index, $event)"
                  />
                </v-col>

                <!-- Show files -->
                <v-col
                  cols="12"
                  md="7"
                  class="mt-4 vertical-line"
                  v-if="box.files.length > 0"
                >
                  <v-row
                    v-for="(file, fIndex) in box.files"
                    :key="fIndex"
                    class="pl-8"
                  >
                    <span
                      @click="previewBoxfile(index, fIndex)"
                      class="file-link"
                      >{{ file.name }}
                    </span>
                    <v-btn
                      icon
                      @click="removeFileBox(index, fIndex)"
                      class="mt-n1"
                    >
                      <v-icon color="red" style="font-size: 16px"
                        >mdi-close</v-icon
                      >
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Date -->
              <v-row>
                <v-col cols="12" md="12" class="mt-4">
                  <h3>
                    Receive Date For Decision Document ({{ labels[index] }})
                  </h3>
                </v-col>
              </v-row>
              <v-row class="mt-n4">
                <v-col cols="12" md="4">
                  <v-menu
                    v-model="box.menuReceiveBox"
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDateToDMY(box.date)"
                        append-icon="mdi-calendar"
                        outlined
                        dense
                        readonly
                        @click="box.menuReceiveBox = true"
                      />
                    </template>
                    <v-date-picker
                      v-model="box.date"
                      @input="box.menuReceiveBox = false"
                    />
                  </v-menu>
                </v-col>

                <!-- Radio -->
                <v-col cols="12" md="8" class="mt-n4">
                  <v-radio-group v-model="box.result">
                    <v-radio
                      v-if="index === 0 || index === 1"
                      label="Successful (สำเร็จ)"
                      value="Successful (สำเร็จ)"
                    />
                    <v-radio
                      v-if="index === 0 || index === 1"
                      label="Unsuccessful (ไม่สำเร็จ)"
                      value="Unsuccessful (ไม่สำเร็จ)"
                    />
                    <v-radio
                      v-if="index === 2"
                      label="Referred to Litigation"
                      value="Referred to Litigation"
                    />
                    <v-radio
                      v-if="index === 2"
                      label="Not Referred to Litigation"
                      value="Not Referred to Litigation"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <v-row justify="space-around mt-n6">
          <v-col cols="12" sm="6" md="6">
            <h3>Description</h3>
            <v-textarea v-model="showaddItem.description" outlined dense>
            </v-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Remark</h3>
            <v-textarea v-model="showaddItem.remark" outlined dense>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row class="mt-n6">
          <v-col cols="4" md="2">
            <h3>Status</h3>
            <v-select
              v-model="showaddItem.closed"
              :items="statuslist"
              item-text="descriptions"
              item-value="module_id"
              outlined
              dense
              @change="sendToStatus"
            ></v-select>
          </v-col>
          <v-col
            cols="4"
            md="3"
            v-if="
              showaddItem.doctype != 701 &&
                showaddItem.doctype != 702 &&
                showaddItem.doctype != 801 &&
                showaddItem.doctype != 802 &&
                showaddItem.doctype != 601 &&
                showaddItem.doctype != 901
            "
          >
            <h3>Reported / Invoiced</h3>
            <v-select
              v-model="showaddItem.report"
              :items="reportlist"
              item-text="report_name"
              item-value="report_value"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
        <!-- ============ SECTION E: การเงิน / INVOICE ============ -->
        <InvoiceSectionPanel
          class="mt-6"
          :sales-order-id.sync="formQutations.salesOrderId"
          :customer-name="formQutations.customerName"
          :price="formQutations.price"
          :currency="formQutations.currency"
          :sales-order-list="salesOrderList"
          :invoice-list="invoiceList"
          :invoice-status-list="invoiceStatusList"
          section-label="E · การเงิน & สถานะ Invoice"
          @select-so="onSelectSO"
          @preview="previewInvoice"
        />
        <v-dialog v-model="dialogpreviewfilenotice" max-width="700px">
          <v-card>
            <v-card-title class="text-h5">
              <v-btn icon @click="closepreviewfile">
                <v-icon large>mdi-close</v-icon>
              </v-btn>
              Preview PDF File</v-card-title
            >

            <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
            <div
              v-if="checkfileapreview"
              v-for="(item, index) in previewpopupfile2"
              :key="index"
            >
              <pdf
                :src="item"
                v-for="i in numPagespreview"
                :key="i"
                :id="i"
                :page="i"
              >
                <template slot="loading"> loading content here... </template>
              </pdf>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closepreviewfile"
                >Cancel</v-btn
              >

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
          <v-card>
            <v-card-title class="text-h5">
              <v-btn icon @click="closepreviewattachfile">
                <v-icon large>mdi-close</v-icon>
              </v-btn>
              Preview PDF File</v-card-title
            >

            <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
            <div
              v-if="checkattachfileapreview"
              v-for="(item, index) in previewpopupattachfile2"
              :key="index"
            >
              <pdf
                :src="item"
                v-for="i in numPagespreviewattach"
                :key="i"
                :id="i"
                :page="i"
              >
                <template slot="loading"> loading content here... </template>
              </pdf>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closepreviewattachfile"
                >Cancel</v-btn
              >

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
          <v-card>
            <v-card-title class="text-h5">
              <v-btn icon @click="closepreviewattachimage">
                <v-icon large>mdi-close</v-icon>
              </v-btn>
              Preview Image</v-card-title
            >

            <v-img
              disabled
              :src="previewattachimage"
              class="grey lighten-2 mt-3 mb-5"
              aspect-ratio="1"
              contain
            >
            </v-img>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closepreviewattachimage"
                >Cancel</v-btn
              >

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogconfirmdeletenoticefile" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this file?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closedialogconfirmdeletenoticefile"
                >Cancel</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="deletedialogconfirmdeletenoticefile"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this file?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closedialogconfirmdeleteattachfile"
                >Cancel</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="deletedialogconfirmdeleteattachfile"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
    <v-card-text v-if="tabselect == 1">
      <TimeLineOperations
        :showaddItem="showaddItem"
        :statuslist="statuslist"
        :reportlist="reportlist"
        :modeOperations="modeOperations"
        :timelineStatus="timelineStatus"
        :status_note="status_note"
        :visible_check="visible_check"
        :showReportInv="true"
        :module_name="module_name"
        :timeline_case_id="timeline_case_id"
        @timelineStatus="timelineStatus = $event"
        @requestStatus="handleRequestStatus"
        @update:status_note="status_note = $event"
        @update:visible_check="visible_check = $event"
      />
    </v-card-text>
    <v-card-actions class="mt-8">
      <v-spacer></v-spacer>
      <!-- <v-btn
          depressed
          width="100"
          class="mr-3 buttonred"
          @click="$router.back()"
        >
          Delete
        </v-btn> -->
      <v-btn
        depressed
        :class="['mr-3 buttongold', { 'is-locked': requestPaymentDisabled }]"
        title="เปิดใช้เมื่อมี Price + Quotation ID + File No. แล้วเท่านั้น"
        @click="requestPaymentDisabled ? null : saveaddItem('paymentrequest')"
      >
        Payment Request
      </v-btn>
      <v-btn
        depressed
        width="100"
        class="mr-3 buttonblue"
        @click="saveaddItem('save')"
      >
        Save
      </v-btn>
      <v-btn depressed outlined width="100" @click="$router.back()">
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- </v-card> -->

    <v-dialog v-model="dialogpreviewfilenotice" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkfileapreview"
          v-for="(item, index) in previewpopupfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreview"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkattachfileapreview"
          v-for="(item, index) in previewpopupattachfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreviewattach"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title
        >

        <v-img
          disabled
          :src="previewattachimage"
          class="grey lighten-2 mt-3 mb-5"
          aspect-ratio="1"
          contain
        >
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachimage"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeletenoticefile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closedialogconfirmdeletenoticefile"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeletenoticefile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closedialogconfirmdeleteattachfile"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeleteattachfile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogconfirmdeleteattrecipt" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewreceipt"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeletereceipt"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCheckbox" max-width="250px" persistent>
      <v-card class="pr-6 pl-6">
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="checkboxes.Form001"
            label="Form 001ก"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Descriptions"
            label="Descriptions"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Claims"
            label="Claims"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Drawings"
            label="Drawings"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Abstract"
            label="Abstract"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="cancelCheckbox">Cancel</v-btn>
          <v-btn color="primary" text @click="saveSelection">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card class="pa-10" style="border: 5px solid #e5e7eb;">
        <v-card-title style="padding-bottom: 20px;">
          <v-row justify="center">
            <span class="text-h4 font-weight-bold"
              >Timeline Update Required</span
            >
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center" class="text-center">
            <span class="black--text text-body-1">
              Before saving this case, please update the internal timeline so
              the team can see the latest work status.
            </span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-top: 20px">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            width="170"
            class="mr-3 "
            color="#0A7EA5"
            @click="deleteItemConfirm"
            style="border-radius: 20px; color: white; text-transform: none;"
          >
            Update Timeline
          </v-btn>
          <v-btn
            depressed
            width="170"
            @click="closeDelete"
            color="red"
            style="border-radius: 20px; color: white; text-transform: none;"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <!-- <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card> -->
    </v-dialog>
    <v-dialog v-model="dialogOutstanding" max-width="560px" persistent>
      <v-card class="outstanding-card">
        <div class="outstanding-header">
          <div class="outstanding-icon">
            <v-icon color="#B7791F" size="34">mdi-alert-outline</v-icon>
          </div>
          <div class="outstanding-title">Outstanding invoice found</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="continueAnyway">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="outstanding-body">
          <p class="outstanding-text">
            This customer has an unpaid invoice.
          </p>

          <div
            v-for="inv in outstandingInvoices"
            :key="inv.inv_h_id"
            class="outstanding-box"
          >
            <div class="outstanding-col">
              <div class="outstanding-label">Customer</div>
              <div class="outstanding-value">
                {{ inv.cus_name || "-" }}
              </div>
            </div>
            <div class="outstanding-divider"></div>
            <div class="outstanding-col">
              <div class="outstanding-label">Invoice number</div>
              <div class="outstanding-value">{{ inv.inv_no }}</div>
            </div>
            <v-spacer></v-spacer>
            <span class="outstanding-chip">{{ inv.status_name }}</span>
          </div>

          <p class="outstanding-hint">
            Please review the outstanding invoice before continuing.
          </p>
        </div>

        <div class="outstanding-separator"></div>

        <div class="outstanding-actions">
          <v-spacer></v-spacer>
          <v-btn outlined large class="btn-back" @click="backToList">
            Back to list
          </v-btn>
          <v-btn
            large
            depressed
            dark
            color="#1D2B4F"
            class="btn-continue"
            @click="continueAnyway"
          >
            Continue anyway
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />

    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
    <SuccessDialogPushpaymentIM
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
      :querydata="querydata"
    />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import pdfvuer from "pdfvuer";
import { apiKeyTiny } from "../../../services/constants";
import TimeLineOperations from "../../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../../payment-invoice/InvoiceSectionPanel.vue";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
export default {
  name: "About",
  data() {
    return {
      menuaddappdate: false,
      app_noshow: "",
      querydata: {},
      dataappiontment: {},
      filedfinaldeadlineninety_date: "",
      // new Date(
      //   Date.now() - new Date().getTimezoneOffset() * 60000
      // )
      //   .toISOString()
      //   .substr(0, 10),
      filed_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      filedfinaldeadlinesixty_date: "",
      // new Date(
      //   Date.now() - new Date().getTimezoneOffset() * 60000
      // )
      //   .toISOString()
      //   .substr(0, 10),
      filed_date: "",
      issuingcer_date: "",
      // receive_date: null,
      receive_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10),
      date_of_renewal_receive: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10),
      enddate: null,
      internaldate: null,
      sourcetypelist: ["Notice", "Mail", "Auto"],
      selectedtrademarkworktype: {},
      menufiledfinaldeadlinesixty_date: false,
      menufiledfinaldeadlineninety_date: false,
      menufiled_date: false,
      menuissuingcer_date: false,
      menureceive_date: false,
      menustartdate: false,
      menuenddate: false,
      menuinternaldate: false,
      radioValueDisable: false,
      message: "Welcome to Vue.js!",
      file_no_list: [],
      objecttype_list: [],
      documenttype_list: [],
      documenttype_listAll: [],
      notice_list: [],
      showapp_no: "",
      showaddItem: {
        new_filling: null,
        report: 0,
        closed: 1,
        filling_date: null,
        date_of_renewal: null,
        date_of_renewal_filed: null,
        filling_date: null,
        objecttype: "",
        doctype: 0,
        refno: "",
        trademark_name: "",
        paymentrequest: 0,

        receive_date: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        ),
        date_of_renewal_receive: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        ),
        startdate: null,
        enddate: null,
        internaldate: null,
        issuingcer_date: "",
        filed_date: "",
        filedfinaldeadlinesixty_date: "",

        filedfinaldeadlineninety_date: "",

        categories: "",
        description: "",
        remark: "",
        nextdeadlineninety: false,
        nextdeadlinesixty: false,
        paymentrequest: false,
        cert: false,
        done: false,
        sourcetype: "",
        notice: "",
        action: "",
      },
      date_of_renewal: null,
      date_of_renewal_filed: null,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      image_listattach: [],
      filenameattach: [],
      getpreview_listattach: [],
      preview_listattach2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      numPagespreviewattach: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      previewattachimage: "",
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      indexdeleteattachfile: -1,
      indexdeletenoti: -1,
      customer_id_forpatmentrequest: 0,
      customer_name_list: [],
      associate_contact_name: "",
      agent_contact_name: "",
      doctype_actions_select: [],
      doctype_actions_tlist: [],
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      preview_listrecicpt: [],
      image_listattach: [],
      image_listrecicpt: [],
      filenameattach: [],
      filenamerecive: [],
      getpreview_listattach: [],
      getpreview_listreceipt: [],
      preview_listattach2: [],
      preview_listrecipt2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      checkboxFields: {
        Form001: "Form 001ก",
        Descriptions: "Descriptions",
        Claims: "Claims",
        Drawings: "Drawings",
        Abstract: "Abstract",
      },
      checkboxes: {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      },
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      dialogconfirmdeleteattrecipt: false,
      indexdeleteattachfile: -1,
      indexdeleteattreciept: -1,
      indexdeleteattachfilelist: -1,
      customer_id_forpatmentrequest: 0,
      dialogCheckbox: false,
      uploadedFiles: {},
      uploadedFilesDoctype: {},
      fileList_good_service: [],
      statuslist: [
        // { status_name: "Pending", status_value: 1 },
        // { status_name: "Completed", status_value: 2 },
        // { status_name: "Close", status_value: 3 },
      ],
      reportlist: [
        { report_name: "Not Reported", report_value: 0 },
        { report_name: "Reported", report_value: 4 },
        { report_name: "Reported – Pending Invoice", report_value: 1 },
        { report_name: "Invoiced", report_value: 2 },
        { report_name: "Reported & Invoiced", report_value: 3 },
      ],
      menuRenewalReceive: false,
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuaddlapd: false,
      menuDeadline: false,
      filling_date: null,
      data_maserter_pt: [],
      radioValue: null,
      radioDateSelect: null,
      defaultCulDate: true,
      softFile: true,
      goodServiceFile: true,
      decisionBoxes: [
        { files: [], date: "", level: 1, menuReceiveBox: false, result: "" },
      ],
      labels: [
        "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
        "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
        "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
      ],
      contact_agent_list: [],
      contact_associate_list: [],
      contact_owner_list: [],
      dataFileAll: [],
      menuaddnewfilling: false,
      new_filling: null,
      oldfileno: "",
      menurenewal: false,
      menurenewal_filed: false,
      data_maserter_pt_priority: [],

      //time line constant
      timelineStatus: 0,
      status_note: "",
      visible_check: false,
      dialogDelete: false,
      timeline_case_id: 0,
      module_name: "Trademark Docket",
      modeOperations: "New",
      tabselect: 0,

      //quotations
      formQutations: {
        salesOrderId: 0,
        price: 0,
        customerName: "",
        currency: "",
      },
      salesOrderList: [],
      invoiceList: [],
      // invoiceMenu: false,
      // invoiceMenuPay: false,
      invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
      quotationscheckstatus: "",
      // outstanding invoice dialog
      dialogOutstanding: false,
      outstandingInvoices: [],
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    pdf: pdfvuer,
    TimeLineOperations,
    InvoiceSectionPanel,
  },
  watch: {
    new_filling(val) {
      this.showaddItem.new_filling = this.formatDate(this.new_filling);
    },
    filling_date(val) {
      this.showaddItem.filling_date = this.formatDate(this.filling_date);
    },
    receive_date(val) {
      this.showaddItem.receive_date = this.formatDate(this.receive_date);
    },
    date_of_renewal_receive(val) {
      this.showaddItem.date_of_renewal_receive = this.formatDate(
        this.date_of_renewal_receive,
      );
    },
    enddate(val) {
      this.showaddItem.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.showaddItem.internaldate = this.formatDate(this.internaldate);
    },
    issuingcer_date(val) {
      this.showaddItem.issuingcer_date = this.formatDate(this.issuingcer_date);
    },
    filed_date(val) {
      this.showaddItem.filed_date = this.formatDate(this.filed_date);
    },
    filedfinaldeadlinesixty_date(val) {
      this.showaddItem.filedfinaldeadlinesixty_date = this.formatDate(
        this.filedfinaldeadlinesixty_date,
      );
    },
    filedfinaldeadlineninety_date(val) {
      this.showaddItem.filedfinaldeadlineninety_date = this.formatDate(
        this.filedfinaldeadlineninety_date,
      );
    },
    date_of_renewal(val) {
      this.showaddItem.date_of_renewal = this.formatDate(this.date_of_renewal);
    },
    date_of_renewal_filed(val) {
      this.showaddItem.date_of_renewal_filed = this.formatDate(
        this.date_of_renewal_filed,
      );
    },
  },
  computed: {
    requestPaymentDisabled() {
      const price = Number(this.formQutations.price);
      const salesOrderId = Number(this.formQutations.salesOrderId);

      const isPriceValid = !isNaN(price) && price > 0;
      const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
      const isFileNoValid = !!(this.showaddItem.refno || "").trim();

      return !(isPriceValid && isSalesOrderIdValid && isFileNoValid);
    },
  },
  async mounted() {
    await this.loadStatusList();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatadocumenttype();
    await this.loaddatanotice();
    await this.loadCustomer();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loadDataDotypeAction();
    await this.loaddatafile_no();
    await this.loaddataSalesOrder();

    if (this.showapp_no !== "" && this.showaddItem.refno !== "") {
      // --------------- check data in ocr table ----------------
      let ocr_data = await api.checkAppointmentOCR(
        this.showapp_no,
        this.showaddItem.refno,
      );

      if (ocr_data.data !== null) {
        let map_data = await api.mapKeyWordTM(
          this.showapp_no,
          this.showaddItem.refno,
        );

        this.showaddItem.doctype = map_data.data.doctype_id;
        this.showaddItem.notice = map_data.data.notice_type;
      } else {
      }

      // --------------- check data in map table ----------------
    }

    this.$hideLoader();
  },
  methods: {
    // [NEW] เช็ค outstanding invoice สำหรับหน้า Add (ตอนกด Enter ที่ File No.)
    // เรียกผ่าน httpClientSilent: ถ้า API ตอบ 404/500 จะไม่ redirect ออกจากหน้า
    async checkOutstandingInvoiceOnAdd(fileNo) {
      try {
        const res = await api.getOutstandingInvoiceByBillingCustomerSilent(
          fileNo,
        );
        const rows = res && Array.isArray(res.data) ? res.data : [];
        if (rows.length > 0) {
          this.outstandingInvoices = rows;
          this.dialogOutstanding = true;
        } else {
          this.outstandingInvoices = [];
        }
      } catch (error) {
        this.outstandingInvoices = [];
        console.warn(
          "checkOutstandingInvoiceOnAdd skipped:",
          error && error.message ? error.message : error,
        );
      }
    },
    async checkOutstandingInvoice(fileNo) {
      try {
        const res = await api.getOutstandingInvoiceByBillingCustomer(fileNo);
        const rows = res.data || [];
        if (rows.length > 0) {
          this.outstandingInvoices = rows;
          this.dialogOutstanding = true;
        } else {
          this.outstandingInvoices = [];
        }
      } catch (error) {
        console.error("checkOutstandingInvoice error:", error);
      }
    },
    backToList() {
      this.dialogOutstanding = false;
      this.$router.push("/appointment-trademark-list");
    },
    continueAnyway() {
      this.dialogOutstanding = false;
    },
    //quotations
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(
          Number(localStorage.getItem(server.COMPANYID)),
        );
        this.salesOrderList = res.data || [];
      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(so) {
      // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
      if (!so) {
        this.formQutations.price = "";
        this.formQutations.customerName = "";
        this.formQutations.currency = "";
        this.quotationscheckstatus = "";
        return;
      }
      this.quotationscheckstatus = so.status;
      this.formQutations.price = Number(so.subtotal);
      this.formQutations.customerName = so.customer_name || "";
      this.formQutations.currency = so.currency || "";
    },
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`,
      );
      window.open(routeData.href, "_blank");
    },
    //end quotattions
    handleRequestStatus(value) {
      this.showaddItem.closed = Number(value);
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        (item) => item.module_id === value,
      );
      this.timelineStatus = Number(selectedItem.timeline_status_id);
    },
    async loadStatusList() {
      const result = await api.getClientTimelineStatusCongFigByModule(
        "Trademark Docket",
      );

      this.statuslist = (result.data || []).map((item) => ({
        ...item,
        module_id: Number(item.module_id),
      }));

      const selectedItem = this.statuslist.find(
        (item) => Number(item.module_id) === Number(this.showaddItem.closed),
      );
      this.timelineStatus = Number(selectedItem.timeline_status_id);
    },
    clearEndDate() {
      this.showaddItem.enddate = null;
      this.enddate = null;
      this.showaddItem.internaldate = null;
      this.internaldate = null;
      this.radioValue = null;
      this.radioDateSelect = null;
      this.radioValueDisable = true;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    async loadDataDotypeAction() {
      const res_doctye_actions = await api.getbyobjectgroup_id(1);
      this.doctype_actions_tlist = res_doctye_actions.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_name_list = result.data;
    },
    async loaddatafile_no() {
      this.showaddItem.refno = this.$route.params.file_no;
      if (this.showaddItem.refno.trim() != "") {
        this.onSearchfile_no(this.showaddItem.refno);
      } else {
        this.showaddItem.refno = "";
      }
    },
    objecttypeSelect() {
      if (
        this.showaddItem.objecttype != 0 &&
        this.showaddItem.objecttype != ""
      ) {
        this.documenttype_list = this.documenttype_listAll.filter(
          (item) =>
            Number(item.objecttype_id) === Number(this.showaddItem.objecttype),
        );

        this.showaddItem.doctype = 0;
      }
    },
    formatDateToDMY(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDMYToISO(dmy) {
      // แปลงจาก DD/MM/YYYY → YYYY-MM-DD สำหรับเก็บใน v-model ของ v-date-picker
      if (!dmy) return null;
      const [day, month, year] = dmy.split("/");
      return `${year}-${month}-${day}`;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },

    async saveaddItem(mode) {
      var dataset = [];
      if (this.showaddItem.objecttype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.showaddItem.doctype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Work Type ",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (this.showaddItem.refno == "" || this.showaddItem.refno == null) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put File No.",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (mode == "paymentrequest") {
        const checkMaterTm = await api.getByFileNoTmMatter(
          this.showaddItem.refno,
        );

        if (checkMaterTm.data.length > 0) {
          dataset = checkMaterTm.data[0];

          if (!dataset.cus_billing_id || dataset.cus_billing_id == "") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data ",
              "Please verify the customer's billing details.",
              "text-h5 red--text text-center",
            );
            return;
          }
          // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่ผูกกับแฟ้มนี้
          if (this.formQutations.salesOrderId) {
            const selectedSO = this.salesOrderList.find(
              (item) =>
                Number(item.quotation_id) ===
                Number(this.formQutations.salesOrderId),
            );

            if (!selectedSO) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Check data",
                "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
                "text-h5 red--text text-center",
              );
              return;
            }

            if (
              Number(selectedSO.client_id) !== Number(dataset.cus_billing_id)
            ) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "ข้อมูลลูกค้าไม่ตรงกัน",
                `ใบเสนอราคา ${
                  selectedSO.doc_no
                } เป็นของลูกค้า "${selectedSO.customer_name ||
                  "-"}" ซึ่งไม่ตรงกับลูกค้าในแฟ้มนี้`,
                "text-h5 red--text text-center",
              );
              return;
            }
          }
        }
      }
      if (
        [
          1,
          2,
          4,
          5,
          6,
          9,
          10,
          19,
          104,
          105,
          108,
          110,
          111,
          112,
          113,
          115,
          312,
          601,
          901,
          701,
          702,
          801,
          802,
          1002,
          1003,
          1004,
          1005,
          1006,
          1007,
          1009,
          1011,
        ].includes(this.showaddItem.doctype)
      ) {
        if (
          this.showaddItem.receive_date == "" ||
          this.showaddItem.receive_date == null
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Receive Date",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
      if (
        [
          2,
          5,
          1,
          9,
          19,
          4,
          6,
          10,
          111,
          115,
          112,
          110,
          113,
          105,
          108,
          104,
          312,
          701,
          702,
          801,
          802,
          1002,
          1003,
          1004,
          1005,
          1006,
          1007,
          1009,
          1011,
        ].includes(this.showaddItem.doctype)
      ) {
        if (
          this.showaddItem.enddate == "" ||
          this.showaddItem.enddate == null
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Final Deadline",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
      if (
        this.showaddItem.doctype == 7 ||
        this.showaddItem.doctype == 107 ||
        this.showaddItem.doctype == 1001
      ) {
        if (
          this.showaddItem.receive_date == "" ||
          this.showaddItem.receive_date == null
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Application Date",
            "text-h5 red--text text-center",
          );
          return;
        }
        if (this.showaddItem.app_no == "" || this.showaddItem.app_no == null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Application No.",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
      if (
        this.showaddItem.doctype == 8 ||
        this.showaddItem.doctype == 109 ||
        this.showaddItem.doctype == 1010
      ) {
        if (
          this.showaddItem.receive_date == "" ||
          this.showaddItem.receive_date == null
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Receive Date",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
      if (
        this.showaddItem.doctype == 9 ||
        this.showaddItem.doctype == 110 ||
        this.showaddItem.doctype == 1005 ||
        this.showaddItem.doctype == 113 ||
        this.showaddItem.doctype == 1006 ||
        this.showaddItem.doctype == 19
      ) {
        for (const [index, item] of this.decisionBoxes.entries()) {
          if (!item.date || !item.result) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data",
              "Please Put Decision Document Data",
              "text-h5 red--text text-center",
            );
            return; // ออกจากฟังก์ชันทันที
          }
        }
      }
      const checkfile_no = await api.getfile_noTmforappointment(
        this.showaddItem.refno,
      );

      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }
      var main_id = 0;
      try {
        if (checkfile_no.data[0]) {
          var dataAddItem = {
            //set defluat
            status: 1,
            objecttype: this.showaddItem.objecttype,
            doctype: this.showaddItem.doctype,
            refno: this.showaddItem.refno.trim(),
            trademark_name: this.showaddItem.trademark_name.trim(),
            categories: "",
            description: this.showaddItem.description,
            lower: "",
            fee: 0,
            remark: this.showaddItem.remark,
            appointment_status: 0,
            extendstatus: 0,
            extendnumber: 0,
            ocr_flag: 0,
            ocrdata_id: 0,
            sourcetype: this.showaddItem.sourcetype,
            report: this.showaddItem.report,
            paymentrequest: 0,
            cert: 0,
            nextdeadlineninety: 0,
            nextdeadlinesixty: 0,
            done: 0,
            closed: this.showaddItem.closed,
            issuingcer_date: null,
            filed_date: null,
            filedfinaldeadlinesixty_date: null,
            filedfinaldeadlineninety_date: null,
            notice_file: "",
            attachment_files: "",
            action: "",
            create_by: Number(localStorage.getItem(server.USER_ID)),
            update_by: null,
            documenttype_action_id: "",
            dead_last_annuity_paid: "",
            last_annuity_paid: null,
            next_annuity_date: null,
            final_due_date_for_next_payment: null,
            owner_contact: this.showaddItem.owner_contact,
            owner_name: this.showaddItem.owner_name,
            agent_contact: this.showaddItem.agent_contact,
            associate_contact: this.showaddItem.associate_contact,
            user_note: "",
            translation_status: "",

            //set ตามเงือนไข
            receive_date: null, // this.changeformatDatetoinsert(this.showaddItem.receive_date),
            startdate: null, // this.changeformatDatetoinsert(this.showaddItem.receive_date),
            enddate: null, // enddate: this.changeformatDatetoinsert(this.showaddItem.enddate),
            internaldate: null, // internaldate: this.changeformatDatetoinsert(  this.showaddItem.internaldate),
            filling_date: null, // filling_date: this.changeformatDatetoinsert(  this.showaddItem.filling_date ),
            new_filling: null,
            date_of_renewal_filed: null,
            date_of_renewal: null,
            date_of_renewal_receive: null,
            date_select: "",
            quotation_id: this.formQutations.salesOrderId,
          };
          if (
            [
              1,
              2,
              4,
              5,
              6,
              9,
              10,
              19,
              104,
              105,
              108,
              110,
              111,
              112,
              113,
              115,
              701,
              702,
              801,
              802,
              1002,
              1003,
              1004,
              1005,
              1006,
              1007,
              1009,
              1011,
            ].includes(Number(this.showaddItem.doctype))
          ) {
            dataAddItem.receive_date = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.startdate = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.enddate = this.changeformatDatetoinsert(
              this.showaddItem.enddate,
            );
            dataAddItem.internaldate = this.changeformatDatetoinsert(
              this.showaddItem.internaldate,
            );
            dataAddItem.filling_date = this.changeformatDatetoinsert(
              this.showaddItem.filling_date,
            );

            if (this.radioValue == "60") {
              dataAddItem.nextdeadlinesixty = 1;
              dataAddItem.nextdeadlineninety = 0;
            } else if (this.radioValue == "90") {
              dataAddItem.nextdeadlinesixty = 0;
              dataAddItem.nextdeadlineninety = 1;
            } else {
              dataAddItem.nextdeadlinesixty = 0;
              dataAddItem.nextdeadlineninety = 0;
            }
            if (this.radioDateSelect == "receive_date") {
              dataAddItem.date_select = "receive_date";
            } else if (this.radioDateSelect == "application_date") {
              dataAddItem.date_select = "application_date";
            } else {
              dataAddItem.date_select = "";
            }
          }
          if (Number(this.showaddItem.doctype) == 312) {
            dataAddItem.receive_date = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.enddate = this.changeformatDatetoinsert(
              this.showaddItem.enddate,
            );
            dataAddItem.internaldate = this.changeformatDatetoinsert(
              this.showaddItem.internaldate,
            );
            dataAddItem.filling_date = this.changeformatDatetoinsert(
              this.showaddItem.filling_date,
            );
          }
          if (
            Number(this.showaddItem.doctype) == 7 ||
            Number(this.showaddItem.doctype) == 107 ||
            Number(this.showaddItem.doctype) == 1001
          ) {
            dataAddItem.receive_date = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.startdate = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.new_filling = this.changeformatDatetoinsert(
              this.showaddItem.new_filling,
            );
            dataAddItem.internaldate = this.changeformatDatetoinsert(
              this.showaddItem.internaldate,
            );
          }
          if (
            Number(this.showaddItem.doctype) == 8 ||
            Number(this.showaddItem.doctype) == 109 ||
            Number(this.showaddItem.doctype) == 601 ||
            Number(this.showaddItem.doctype) == 901 ||
            Number(this.showaddItem.doctype) == 1010
          ) {
            dataAddItem.receive_date = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.startdate = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.filling_date = this.changeformatDatetoinsert(
              this.showaddItem.filling_date,
            );
          }
          if (
            Number(this.showaddItem.doctype) == 3 ||
            Number(this.showaddItem.doctype) == 106 ||
            Number(this.showaddItem.doctype) == 1008
          ) {
            dataAddItem.date_of_renewal_receive = this.changeformatDatetoinsert(
              this.showaddItem.date_of_renewal_receive,
            );
            dataAddItem.receive_date = this.changeformatDatetoinsert(
              this.showaddItem.receive_date,
            );
            dataAddItem.date_of_renewal_filed = this.changeformatDatetoinsert(
              this.showaddItem.date_of_renewal_filed,
            );
            dataAddItem.date_of_renewal = this.changeformatDatetoinsert(
              this.showaddItem.date_of_renewal,
            );
          }
          this.$showLoader();
          const resAddData = await api.newAppointment(dataAddItem);

          if (Number(resAddData.status) == 200) {
            try {
              if (this.quotationscheckstatus == "Submitted") {
                var dataupdateStatus = {
                  status: "InProgress",
                };
                await api.updateQuotationsCore(
                  Number(this.formQutations.salesOrderId),
                  dataupdateStatus,
                );
              }
            } catch (quotationsError) {
              console.log(quotationsError);
            }

            main_id = resAddData.data.appointment_id;

            //add timeline
            var dataadd_timeline = {
              timeline_status_id: Number(this.timelineStatus),
              case_id: Number(main_id),
              module_name: "Trademark Docket",
              case_woker: Number(localStorage.getItem(server.USER_ID)),
              status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
              status_note: this.status_note.trim(),
              visibility: this.visible_check,
            };
            const result_add = await api.creategetClientTimelineHistory(
              dataadd_timeline,
            );
            try {
              const caseDetailResult = await api.getgetTimelineDataDetail({
                params: {
                  module_name: this.module_name,
                  case_id: Number(main_id),
                },
              });
              const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

              const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility(
                {
                  params: {
                    module_name: this.module_name,
                    case_id: Number(main_id),
                  },
                },
              );
              const timelineData = visibilityResult.data || [];

              caseInfo.status = timelineData[0]?.status || "";
              caseInfo.lastUpdated = timelineData[0]?.status_time || "";

              const latestUpdate = {
                message: timelineData[0]?.status_note || "",
                date: timelineData[0]?.status_time || "",
              };

              await PDFCaseProgress.createToPDF(
                {
                  caseInfo,
                  latestUpdate,
                  timelineData,
                  caseId: Number(main_id),
                  moduleName: this.module_name,
                },
                { open: false },
              );
            } catch (pdfError) {
              console.error("PDF generation/upload failed:", pdfError);
              // Not re-thrown — the appointment/timeline entry was already created;
              // a PDF failure here shouldn't block the rest of saveaddItem (doctype
              // actions, file uploads, decision documents, etc. that follow).
            }
            //end add timeline

            //create doctype actios
            if (this.doctype_actions_select.length > 0) {
              for (const item of this.doctype_actions_select) {
                var addDataDoctypeActions = {
                  documenttype_action_id: item,
                  appointment_id: Number(main_id),
                  appointment_type: "Trademark",
                  documenttype_follow: 0,
                };
                await api.createAppointmentDoctypeActions(
                  addDataDoctypeActions,
                );
              }
            }

            //add notic
            if (this.image_listnotice.length > 0) {
              this.image_listnotice.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                if (
                  this.showaddItem.doctype == 701 ||
                  this.showaddItem.doctype == 702
                ) {
                  formData.set("fileTypeAdd", `notice_opposition`);
                } else if (
                  this.showaddItem.doctype == 801 ||
                  this.showaddItem.doctype == 802
                ) {
                  formData.set("fileTypeAdd", `notice_cancellation`);
                } else {
                  formData.set("fileTypeAdd", `notice`);
                }

                await api.createDataFile(main_id, formData);
              });
            }

            //add submit
            if (this.image_listattach.length > 0) {
              this.image_listattach.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                if (
                  this.showaddItem.doctype == 701 ||
                  this.showaddItem.doctype == 702 ||
                  this.showaddItem.doctype == 801 ||
                  this.showaddItem.doctype == 802
                ) {
                  formData.set("fileTypeAdd", `counter_argument`);
                } else {
                  formData.set("fileTypeAdd", `submitted`);
                }
                await api.createDataFile(main_id, formData);
              });
            }

            //add reciept file
            if (this.image_listrecicpt.length > 0) {
              this.image_listrecicpt.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `receipt`);
                await api.createDataFile(main_id, formData);
              });
            }
            //add Good5/Service
            if (this.fileList_good_service.length > 0) {
              for (const file of this.fileList_good_service) {
                const csvText = await new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = (e) => resolve(e.target.result);
                  reader.onerror = (err) => reject(err);
                  reader.readAsText(file);
                });

                let resultHTML = "";

                if (!csvText || csvText.trim() === "") {
                  console.log(`⏩ ${file.name} ไม่มีข้อมูล`);
                } else {
                  const lines = csvText
                    .split(/\r?\n/)
                    .filter((line) => line.trim() !== "");

                  if (lines.length >= 2) {
                    const headers = lines[0].split(",").map((h) => h.trim());
                    const dataRows = lines.slice(1).map((line) => {
                      const values = line.split(",").map((v) => v.trim());
                      const obj = {};
                      headers.forEach((h, i) => {
                        obj[h] = values[i] ?? null;
                      });
                      return obj;
                    });

                    if (
                      headers.includes("class") &&
                      headers.includes("product")
                    ) {
                      const grouped = dataRows.reduce((acc, item) => {
                        if (!item.class) return acc;
                        if (!acc[item.class]) acc[item.class] = [];
                        if (item.product) acc[item.class].push(item.product);
                        return acc;
                      }, {});

                      const classKeys = Object.keys(grouped);
                      if (classKeys.length > 0) {
                        classKeys.forEach((cls, idx) => {
                          const products = grouped[cls];
                          const productStr =
                            products.length > 1
                              ? products.join(", ")
                              : products[0];
                          resultHTML += `${cls}: ${productStr}`;
                          if (idx !== classKeys.length - 1)
                            resultHTML += "<br />";
                        });
                      }
                    }
                  }
                }

                // 🔹 เรียก API
                await api.updateMasterTMByFileNo(this.showaddItem.refno, {
                  good_service: resultHTML,
                });
              }
              this.fileList_good_service.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `goodsservice`);
                await api.createDataFile(main_id, formData);
              });
            }
            //add softfile
            const hasFiles = Object.keys(this.uploadedFiles).some(
              (key) =>
                this.uploadedFiles[key] && this.uploadedFiles[key].length > 0,
            );
            if (hasFiles) {
              for (const [key, files] of Object.entries(this.uploadedFiles)) {
                if (files.length > 0) {
                  for (const file of files) {
                    let formData = new FormData();
                    formData.set("file", file);
                    formData.set("fileName", file.name);
                    formData.set("fileKey", key);
                    formData.set("fileType", `softfile`);
                    await api.createDataSoftFile(main_id, formData);
                  }
                }
              }
            }
            if (
              this.showaddItem.doctype == 3 ||
              this.showaddItem.doctype == 106 ||
              this.showaddItem.doctype == 1008
            ) {
              await api.updateMasterTMByFileNo(this.showaddItem.refno, {
                date_of_renewal_filed: this.changeformatDatetoinsert(
                  this.showaddItem.date_of_renewal_filed,
                ),
                date_of_renewal: this.changeformatDatetoinsert(
                  this.showaddItem.date_of_renewal,
                ),
              });
            }
            if (
              this.showaddItem.doctype == 9 ||
              this.showaddItem.doctype == 110 ||
              this.showaddItem.doctype == 1005 ||
              this.showaddItem.doctype == 113 ||
              this.showaddItem.doctype == 1006 ||
              this.showaddItem.doctype == 19 ||
              this.showaddItem.doctype == 702
            ) {
              for (const [index, item] of this.decisionBoxes.entries()) {
                var dataDecisionDocumentAdd = {
                  appointment_id: main_id,
                  level: item.level,
                  result: item.result,
                  date: item.date,
                  type: `appointmentTM`,
                };
                await api.createdecision(dataDecisionDocumentAdd);
                if (item.files.length > 0) {
                  for (const file of item.files) {
                    let formData = new FormData();
                    formData.set("file", file);
                    formData.set("fileName", file.name);
                    formData.set("fileTypeAdd", `decision_level${item.level}`);
                    await api.createDataFile(main_id, formData);
                  }
                }
              }
            }

            if (mode == "paymentrequest") {
              this.$hideLoader();
              var dataPush = {
                customer_name_master: dataset.cus_name,
                yourRef: "",
                ourRef: "",
                docketId: main_id,
                quotation_id: Number(this.formQutations.salesOrderId),
              };

              var custonerId = 0;
              custonerId = Number(dataset.cus_billing_id);
              const hasThai = /[\u0E00-\u0E7F]/;

              if (hasThai.test(dataset.cus_name)) {
                dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${dataset.cliant_ref}`;
                dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${dataset.file_no}`;
              } else {
                dataPush.yourRef = `Your Ref: ${dataset.cliant_ref}`;
                dataPush.ourRef = `Our Ref: ${dataset.file_no}`;
              }
              if (dataset.cliant_ref.trim() == "") {
                dataPush.yourRef = "";
              }
              this.$router.push({
                path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
                query: dataPush,
              });
            } else {
              this.$hideLoader();
              this.$store.state.global_push_dialog = true;
              this.setupAlertDialogPush(
                true,
                "save data",
                "save data success",
                "text-h5 green--text text-center",
                "/appointment-trademark-list",
              );
              return;
            }
          }
        }
      } catch (err) {
        this.$hideLoader();
      }
    },

    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(1);
      this.objecttype_list = result.data;
    },
    async loaddatadocumenttype() {
      const result = await api.getdocumenttype_code();
      this.documenttype_listAll = result.data;
      for (const [index, item] of this.documenttype_listAll.entries()) {
        item.documenttype_id = Number(item.documenttype_id);
      }
    },
    async loaddatanotice() {
      const result = await api.getnotice_code();

      this.notice_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async onSelectCustomerChange(objecttype_id) {
      const resultdocumenttype = await api.getdocumenttype_codeByobjecttype_id(
        objecttype_id,
      );
      this.documenttype_list = resultdocumenttype.data;

      const resultnotice = await api.getnotice_codeByobjecttype_id(
        objecttype_id,
      );
      this.notice_list = resultnotice.data;
      // this.selectedtrademarkworktype = doctype;
      // this.selectedtrademarkworktype = this.documenttype_list.filter((item) => {
      //   if (item.documenttype_id == doctype_id) {
      //     return item;
      //   }
      // });
    },
    async onSelectnoticeChange(doctype_id) {
      this.selectedtrademarkworktype = this.notice_list.filter((item) => {
        if (item.notice_id == doctype_id) {
          return item;
        }
      });
    },
    resetdata() {
      this.app_noshow = "";
      this.showaddItem.new_filling = null;
      this.showaddItem.report = 0;
      this.showaddItem.closed = 1;
      this.showaddItem.filling_date = null;
      this.showaddItem.objecttype = "";
      this.showaddItem.doctype = 0;
      this.showaddItem.trademark_name = "";
      this.showaddItem.paymentrequest = 0;
      this.showaddItem.receive_date = null;
      this.showaddItem.startdate = null;
      this.showaddItem.enddate = null;
      this.showaddItem.internaldate = null;
      this.showaddItem.issuingcer_date = "";
      this.showaddItem.filed_date = "";
      this.showaddItem.filedfinaldeadlinesixty_date = "";
      this.showaddItem.filedfinaldeadlineninety_date = "";
      this.showaddItem.categories = "";
      this.showaddItem.description = "";
      this.showaddItem.remark = "";
      this.showaddItem.nextdeadlineninety = false;
      this.showaddItem.nextdeadlinesixty = false;
      this.showaddItem.paymentrequest = false;
      this.showaddItem.cert = false;
      this.showaddItem.done = false;
      this.showaddItem.sourcetype = "";
      this.showaddItem.notice = "";
      this.showaddItem.action = "";
      this.showaddItem.owner_contact = 0;
      this.showaddItem.agent_contact = 0;
      this.showaddItem.associate_contact = 0;
      this.showaddItem.owner_name = "";
      this.agent_contact_name = "";
      this.associate_contact_name = "";

      this.doctype_actions_select = [];
      this.defaultCulDate = true;
    },
    async onSearchfile_no(file_no) {
      this.$showLoader();
      try {
        if (this.oldfileno != "" && this.oldfileno != file_no) this.resetdata();
        this.resetFileState();

        if (file_no && file_no.trim() != "") {
          this.showaddItem.refno = (this.showaddItem.refno || "")
            .trim()
            .toUpperCase();
          const result = await api.getfile_noTmforappointment(file_no);

          if (result.data[0]) {
            this.app_noshow = result.data[0].app_no;

            if (
              result.data[0].agent_contact &&
              result.data[0].agent_contact != 0
            ) {
              this.showaddItem.agent_contact = result.data[0].agent_contact;

              this.contact_agent_list.filter((item) => {
                if (item.contact_id == this.showaddItem.agent_contact) {
                  this.agent_contact_name = item.contact_name;
                }
              });
            } else {
              this.agent_contact_name = "";
            }

            if (
              result.data[0].associate_contact &&
              result.data[0].associate_contact != 0
            ) {
              this.showaddItem.associate_contact =
                result.data[0].associate_contact;
              this.contact_associate_list.filter((item) => {
                if (item.contact_id == this.showaddItem.associate_contact) {
                  this.associate_contact_name = item.contact_name;
                }
              });
            } else {
              this.associate_contact_name = "";
            }

            this.data_maserter_pt = result.data[0];
            this.showaddItem.owner_contact = result.data[0].owner_contact;
            this.showaddItem.owner_name = result.data[0].name_of_client;
            this.showaddItem.trademark_name = result.data[0].trademark;
            this.showaddItem.objecttype = result.data[0].tm_type;

            // เช็คว่าลูกค้าคนนี้มี invoice ค้าง (เช็คเฉพาะตอนเปลี่ยน File No. กัน dialog ซ้ำ)
            if (this.oldfileno !== file_no) {
              await this.checkOutstandingInvoiceOnAdd(this.showaddItem.refno); // [NEW] ไม่เด้ง dashboard ถ้า API error
            }
            this.oldfileno = file_no;

            const res_priority = await api.getAllMASTERPT_PRIORITY_BYIDTM(
              Number(result.data[0].mastertm_id),
            );

            if (res_priority.data.length > 0) {
              this.data_maserter_pt_priority = res_priority.data;
            }

            this.documenttype_list = this.documenttype_listAll.filter(
              (item) =>
                Number(item.objecttype_id) ===
                Number(this.showaddItem.objecttype),
            );
          } else {
            this.oldfileno = "";
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Search File No. ",
              "File No. not found ",
              "text-h5 red--text text-center",
            );
            return;
          }
        } else {
          this.oldfileno = "";
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Search File No. ",
            "File No. not found ",
            "text-h5 red--text text-center",
          );
          return;
        }
      } catch (error) {
        console.error("onSearchfile_no error:", error);
      } finally {
        this.$hideLoader();
      }
    },
    async Selectchangereceivedate() {
      let setinternaldate = 7;
      if (this.showaddItem.notice == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Notice Type ",
          "text-h5 red--text text-center",
        );
        return;
      }

      this.showaddItem.enddate = new Date(
        new Date(this.changeformatDatetoinsert(this.receive_date)).setDate(
          new Date(this.changeformatDatetoinsert(this.receive_date)).getDate() +
            this.selectedtrademarkworktype[0].numberofenddate,
        ) -
          new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);

      this.showaddItem.enddate = this.formatDate(this.showaddItem.enddate);

      this.showaddItem.internaldate = new Date(
        new Date(
          this.changeformatDatetoinsert(this.showaddItem.enddate),
        ).setDate(
          new Date(
            this.changeformatDatetoinsert(this.showaddItem.enddate),
          ).getDate() - setinternaldate,
        ) -
          new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);
      this.showaddItem.internaldate = this.formatDate(
        this.showaddItem.internaldate,
      );
    },

    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata,
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async calfiledfinaldeadlinesixty_date() {
      if (!this.showaddItem.filed_date) {
        this.showaddItem.nextdeadlinesixty = false;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Filed Date ",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (!this.showaddItem.nextdeadlinesixty) {
        this.showaddItem.filedfinaldeadlinesixty_date = "";
        // this.formatDate(
        //   new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        //     .toISOString()
        //     .substr(0, 10)
        // );
        return;
      }
      this.showaddItem.filedfinaldeadlinesixty_date = new Date(
        new Date(this.filed_date).setDate(
          new Date(this.filed_date).getDate() + 60,
        ) -
          new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);

      this.showaddItem.filedfinaldeadlinesixty_date = this.formatDate(
        this.showaddItem.filedfinaldeadlinesixty_date,
      );
    },
    async calfiledfinaldeadlineninety_date() {
      if (!this.showaddItem.filed_date) {
        this.showaddItem.nextdeadlineninety = false;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Filed Date ",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (!this.showaddItem.nextdeadlineninety) {
        this.showaddItem.filedfinaldeadlineninety_date = "";
        // this.formatDate(
        //   new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        //     .toISOString()
        //     .substr(0, 10)
        // );
        return;
      }
      this.showaddItem.filedfinaldeadlineninety_date = new Date(
        new Date(this.filed_date).setDate(
          new Date(this.filed_date).getDate() + 90,
        ) -
          new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);

      this.showaddItem.filedfinaldeadlineninety_date = this.formatDate(
        this.showaddItem.filedfinaldeadlineninety_date,
      );
    },
    // formatDate(date) {
    //   if (!date) return null;
    //   const [year, month, day] = date.split("-");
    //   return `${year}-${month - 1}-${day}`;
    // },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    fileDoctypeInput() {
      // หาว่า id ไหนถูกลบออก
      const removed = this.prev_doctype_actions_select.filter(
        (id) => !this.doctype_actions_select.includes(id),
      );

      // ลบไฟล์ที่เกี่ยวข้อง
      removed.forEach((id) => {
        this.$delete(this.uploadedFilesDoctype, id);
      });

      // อัปเดตค่าก่อนหน้า
      this.prev_doctype_actions_select = [...this.doctype_actions_select];
    },

    triggerFileInput(key) {
      this.$refs[`fileInput_${key}`][0].click();
    },
    handleFileUpload(event, key) {
      const files = Array.from(event.target.files);

      // เก็บชื่อไฟล์ทั้งหมดที่มีอยู่ใน uploadedFiles ทุก key
      const allUploadedNames = Object.values(this.uploadedFiles)
        .flat()
        .map((f) => f.name);

      if (!this.uploadedFiles[key]) {
        this.$set(this.uploadedFiles, key, []);
      }

      files.forEach((file) => {
        // --- sanitize ชื่อไฟล์ก่อน ---
        let newName = file.name.replace(/[^a-zA-Z0-9.\-_ก-ฮะ-์]/g, "_");

        let baseName = newName;
        let ext = "";

        // แยกนามสกุลไฟล์ (.docx, .doc ฯลฯ)
        const dotIndex = newName.lastIndexOf(".");
        if (dotIndex !== -1) {
          baseName = newName.substring(0, dotIndex);
          ext = newName.substring(dotIndex);
        }

        let counter = 1;
        // ตรวจสอบว่าชื่อไฟล์ซ้ำไหมใน allUploadedNames
        while (allUploadedNames.includes(newName)) {
          newName = `${baseName}-${counter}${ext}`;
          counter++;
        }

        // สร้างไฟล์ใหม่ clone พร้อมชื่อใหม่
        const renamedFile = new File([file], newName, { type: file.type });

        // เพิ่มชื่อใหม่เข้า allUploadedNames เพื่อกันชื่อซ้ำกับไฟล์ถัดไป
        allUploadedNames.push(newName);

        // เพิ่มไฟล์ลงใน uploadedFiles
        this.uploadedFiles[key].push(renamedFile);
      });
    },
    removeFile(key, index) {
      this.uploadedFiles[key].splice(index, 1); // ลบไฟล์ตาม index
    },
    removeFileGood(type, index) {
      let list;
      if (type === "good_service") list = this.fileList_good_service;
      list.splice(index, 1);
    },
    triggerFileInputDoctype(itemId) {
      this.$refs[`fileInput_${itemId}`][0].click();
    },
    handleFileUploadDoctype(event, itemId) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.uploadedFilesDoctype, itemId, file);
      }
    },
    cancelCheckbox() {
      this.dialogCheckbox = false;
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
      this.uploadedFiles = {};
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
    },
    saveSelection() {
      this.dialogCheckbox = false;
    },
    openselectFileWorld() {
      this.dialogCheckbox = true;
    },

    async previewnoticefilepdf(index) {
      var checkfile = this.image_listnotice[index];

      if (checkfile.type == `application/pdf`) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${checkfile}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result; // Base64 image data
          let image_newTab = window.open(""); // เปิดแท็บใหม่
          image_newTab.document.write(`
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  html, body {
                    margin: 50px 0 0 0;
                    height: 80%;
                    overflow: hidden;
                    background-color: black;
                    display: flex;
                    justify-content: center; /* จัดกลางในแนวนอน */
                    align-items: center; /* จัดกลางในแนวตั้ง */
                  }
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                  }
                </style>
              </head>
              <body>
                <img src="${checkfile}" title="Image Preview" />
              </body>
            </html>
          `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfilenotice = false;
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeletereceipt() {
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.getpreview_listreceipt.splice(this.indexdeleteattreciept, 1);
      this.preview_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },

    async previewattachfile(index) {
      if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listattach[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `,
        );

        return;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewattachimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async previewBoxfile(index, fIndex) {
      var dataBoxFile = this.decisionBoxes[index].files[fIndex];
      if (dataBoxFile.isOld) {
        let fileUrl = `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${dataBoxFile.name}`;
        const newTab = window.open("");
        newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body { margin:0; height:100%; overflow:hidden; }
                  iframe { border:none; width:100%; height:100%; }
                </style>
              </head>
              <body>
                <iframe src="${fileUrl}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
        newTab.document.close();
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${fileData}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          pdf_newTab.document.close();
        };
        // ตรงนี้ต้องใช้ dataBoxFile ไม่ใช่ checkfile
        reader.readAsDataURL(dataBoxFile);
      }
    },
    async previewreceiptfile(index) {
      if (this.filenamerecive[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listreceipt[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `,
        );

        return;
      } else {
        this.previewreceipt = this.getpreview_listreceipt[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewreceipt}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },

    fileUrl(file) {
      return URL.createObjectURL(file);
    },
    checktypeFunction() {
      this.resetFileState();
      // this.showaddItem.receive_date = null;
      // this.receive_date = null;

      this.receive_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);
      this.showaddItem.receive_date = this.formatDate(this.receive_date);
      this.showaddItem.filling_date = null;
      this.filling_date = null;
      this.showaddItem.enddate = null;
      this.enddate = null;
      this.showaddItem.internaldate = null;
      this.internaldate = null;
      this.new_filling = null;
      this.showaddItem.new_filling = null;
      this.showaddItem.app_no = null;
      this.radioValueDisable = false;
      this.decisionBoxes = [
        { files: [], date: "", level: 1, menuReceiveBox: false, result: "" },
      ];
      this.radioValue = null;
      this.softFile = false;
      this.goodServiceFile = false;

      this.defaultCulDate = false;
      if (
        this.showaddItem.doctype == 1 ||
        this.showaddItem.doctype == 112 ||
        this.showaddItem.doctype == 1004
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        this.calDateFinalDeadline();
      } else if (
        this.showaddItem.doctype == 2 ||
        this.showaddItem.doctype == 111 ||
        this.showaddItem.doctype == 1002
      ) {
        this.radioValueDisable = true;
        this.radioValue = null;
        this.radioDateSelect = null;
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        // if (
        //   this.data_maserter_pt.date_of_application &&
        //   this.data_maserter_pt.date_of_application != ""
        // ) {
        //   this.showaddItem.enddate = this.formatDate(
        //     this.data_maserter_pt.date_of_application
        //   );
        //   this.enddate = this.data_maserter_pt.date_of_application;
        //   this.onDateSelected();
        // }
      } else if (
        this.showaddItem.doctype == 3 ||
        this.showaddItem.doctype == 106 ||
        this.showaddItem.doctype == 1008
      ) {
        this.defaultCulDate = false;
        this.softFile = true;

        if (
          this.data_maserter_pt.date_of_application &&
          this.data_maserter_pt.date_of_application != ""
        ) {
          // แปลง date_of_application จาก string "yyyy-mm-dd"
          const [
            year,
            month,
            day,
          ] = this.data_maserter_pt.date_of_application.split("-").map(Number);
          let date = new Date(year, month - 1, day);

          // +10 ปี
          date.setFullYear(date.getFullYear() + 10);

          // -1 วัน
          date.setDate(date.getDate() - 1);

          // แปลงเป็น yyyy-mm-dd
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          // เก็บค่า
          this.date_of_renewal = `${yyyy}-${mm}-${dd}`; // yyyy-mm-dd
          this.showaddItem.date_of_renewal = `${dd}/${mm}/${yyyy}`; // dd/mm/yyyy
        }
        if (
          this.data_maserter_pt.date_of_renewal &&
          this.data_maserter_pt.date_of_renewal != ""
        ) {
          // แปลง date_of_renewal จาก string "yyyy-mm-dd"
          const [
            year,
            month,
            day,
          ] = this.data_maserter_pt.date_of_renewal.split("-").map(Number);
          let date = new Date(year, month - 1, day);

          // +90 วัน
          date.setDate(date.getDate() + 90);

          // แปลงเป็น yyyy-mm-dd
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          // เก็บค่า
          this.date_of_renewal_filed = `${yyyy}-${mm}-${dd}`; // yyyy-mm-dd
          this.showaddItem.date_of_renewal_filed = `${dd}/${mm}/${yyyy}`; // dd/mm/yyyy
          // dd/mm/yyyy
        }
      }
      if (
        this.showaddItem.doctype == 4 ||
        this.showaddItem.doctype == 105 ||
        this.showaddItem.doctype == 1007
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        this.calDateFinalDeadline();
      }
      if (
        this.showaddItem.doctype == 5 ||
        this.showaddItem.doctype == 115 ||
        this.showaddItem.doctype == 1003
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        this.calDateFinalDeadline();
      }
      if (
        this.showaddItem.doctype == 701 ||
        this.showaddItem.doctype == 702 ||
        this.showaddItem.doctype == 801 ||
        this.showaddItem.doctype == 802
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        if (
          this.showaddItem.doctype == 701 ||
          this.showaddItem.doctype == 802
        ) {
          this.radioValueDisable = true;
          this.radioValue = null;
          this.radioDateSelect = null;
        } else {
          this.calDateFinalDeadline();
        }
      }
      if (
        this.showaddItem.doctype == 6 ||
        this.showaddItem.doctype == 108 ||
        this.showaddItem.doctype == 1009
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        this.calDateFinalDeadline();
      }
      if (
        this.showaddItem.doctype == 312 ||
        this.showaddItem.doctype == 601 ||
        this.showaddItem.doctype == 901
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
      }
      if (
        this.showaddItem.doctype == 7 ||
        this.showaddItem.doctype == 107 ||
        this.showaddItem.doctype == 1001
      ) {
        this.defaultCulDate = false;
        this.goodServiceFile = true;
        if (this.data_maserter_pt_priority.length > 0) {
          const sorted = [...this.data_maserter_pt_priority].sort(
            (a, b) => new Date(a.priority_date) - new Date(b.priority_date),
          );
          const oldest = sorted[0]?.priority_date;
          if (oldest !== undefined && oldest) {
            const [y, m, d] = oldest.split("-").map(Number);
            const date = new Date(y, m - 1, d);

            // บวก 6 เดือนเสมอ
            date.setMonth(date.getMonth() + 6);

            this.showaddItem.new_filling = `${String(date.getDate()).padStart(
              2,
              "0",
            )}/${String(date.getMonth() + 1).padStart(
              2,
              "0",
            )}/${date.getFullYear()}`;
          }
        }
        if (
          this.data_maserter_pt.date_of_application &&
          this.data_maserter_pt.date_of_application != ""
        ) {
          this.showaddItem.receive_date = this.formatDate(
            this.data_maserter_pt.date_of_application,
          );
          this.receive_date = this.data_maserter_pt.date_of_application;

          this.showaddItem.app_no = this.data_maserter_pt.app_no;
        }
      }
      if (
        this.showaddItem.doctype == 8 ||
        this.showaddItem.doctype == 109 ||
        this.showaddItem.doctype == 1010
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
      }
      if (
        this.showaddItem.doctype == 9 ||
        this.showaddItem.doctype == 110 ||
        this.showaddItem.doctype == 1005
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        if (
          this.data_maserter_pt.date_of_application &&
          this.data_maserter_pt.date_of_application != ""
        ) {
          this.showaddItem.enddate = this.formatDate(
            this.data_maserter_pt.date_of_application,
          );
          this.enddate = this.data_maserter_pt.date_of_application;
          this.onDateSelected();
        }
      }
      if (
        this.showaddItem.doctype == 10 ||
        this.showaddItem.doctype == 104 ||
        this.showaddItem.doctype == 1011
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        this.calDateFinalDeadline();
      }
      if (
        this.showaddItem.doctype == 19 ||
        this.showaddItem.doctype == 113 ||
        this.showaddItem.doctype == 1006
      ) {
        this.defaultCulDate = true;
        this.goodServiceFile = true;
        if (
          this.data_maserter_pt.date_of_application &&
          this.data_maserter_pt.date_of_application != ""
        ) {
          this.showaddItem.enddate = this.formatDate(
            this.data_maserter_pt.date_of_application,
          );
          this.enddate = this.data_maserter_pt.date_of_application;
          this.onDateSelected();
        }
      }
    },
    calDateFinalDeadline() {
      if (this.showaddItem.doctype != 0 && this.showaddItem.doctype) {
        if (
          this.showaddItem.doctype == 1 ||
          this.showaddItem.doctype == 112 ||
          this.showaddItem.doctype == 1004
        ) {
          const dataItem = this.documenttype_list.find(
            (item) => item.documenttype_id === this.showaddItem.doctype,
          );

          const dateplus = dataItem?.numberofenddate
            ? dataItem.numberofenddate - 1
            : 0;

          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setDate(date.getDate() + dateplus);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          this.showaddItem.enddate = `${dd}/${mm}/${yyyy}`;
          this.enddate = `${yyyy}-${mm}-${dd}`;
          const internalDate = new Date(date);
          internalDate.setDate(internalDate.getDate() - 7);

          const idd = String(internalDate.getDate()).padStart(2, "0");
          const imm = String(internalDate.getMonth() + 1).padStart(2, "0");
          const iyyyy = internalDate.getFullYear();
          this.showaddItem.internaldate = `${idd}/${imm}/${iyyyy}`;
          this.internaldate = `${iyyyy}-${imm}-${idd}`;
        } else if (
          this.showaddItem.doctype == 4 ||
          this.showaddItem.doctype == 105 ||
          this.showaddItem.doctype == 1007
        ) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);

          // บวก 60 วัน
          date.setDate(date.getDate() + 60);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          this.showaddItem.enddate = `${dd}/${mm}/${yyyy}`;
          this.enddate = `${yyyy}-${mm}-${dd}`;

          this.onDateSelected();
        } else if (
          this.showaddItem.doctype == 5 ||
          this.showaddItem.doctype == 115 ||
          this.showaddItem.doctype == 1003
        ) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);

          // บวก 60 วัน
          date.setDate(date.getDate() + 60);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          this.showaddItem.enddate = `${dd}/${mm}/${yyyy}`;
          this.enddate = `${yyyy}-${mm}-${dd}`;

          this.onDateSelected();
        } else if (
          this.showaddItem.doctype == 6 ||
          this.showaddItem.doctype == 108 ||
          this.showaddItem.doctype == 1009
        ) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);

          // บวก 60 วัน
          date.setDate(date.getDate() + 60);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          this.showaddItem.enddate = `${dd}/${mm}/${yyyy}`;
          this.enddate = `${yyyy}-${mm}-${dd}`;

          this.onDateSelected();
        } else if (
          this.showaddItem.doctype == 10 ||
          this.showaddItem.doctype == 104 ||
          this.showaddItem.doctype == 1011
        ) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);

          // บวก 60 วัน
          date.setDate(date.getDate() + 60);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          this.showaddItem.enddate = `${dd}/${mm}/${yyyy}`;
          this.enddate = `${yyyy}-${mm}-${dd}`;

          this.onDateSelected();
        } else if (
          this.showaddItem.doctype == 702 ||
          this.showaddItem.doctype == 801
        ) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);

          // บวก 60 วัน
          date.setDate(date.getDate() + Number(this.radioValue));

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");

          this.showaddItem.enddate = `${dd}/${mm}/${yyyy}`;
          this.enddate = `${yyyy}-${mm}-${dd}`;
          this.onDateSelected();
        } else if (
          this.showaddItem.doctype == 2 ||
          this.showaddItem.doctype == 111 ||
          this.showaddItem.doctype == 701 ||
          this.showaddItem.doctype == 802 ||
          this.showaddItem.doctype == 1002
        ) {
          if (this.radioValue && this.radioDateSelect) {
            this.onRadioSelected();
          } else {
            this.radioValueDisable = true;
            this.showaddItem.enddate = null;
            this.enddate = null;
            this.showaddItem.internaldate = null;
            this.internaldate = null;
          }
        }
      } else {
        this.receive_date = null;
        this.showaddItem.receive_date = null;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    onRadioSelectedDateType() {
      if (this.radioDateSelect) {
        this.radioValueDisable = false;
        this.radioValue = null;
        this.showaddItem.enddate = null;
        this.enddate = null;
        this.showaddItem.internaldate = null;
        this.internaldate = null;
      }
    },
    onRadioSelected() {
      if (
        this.showaddItem.doctype == 2 ||
        this.showaddItem.doctype == 111 ||
        this.showaddItem.doctype == 701 ||
        this.showaddItem.doctype == 802 ||
        this.showaddItem.doctype == 1002
      ) {
        if (this.radioDateSelect == "receive_date") {
          if (this.receive_date && this.radioValue) {
            // === คำนวณ enddate (บวกวัน) ===
            const [year, month, day] = this.receive_date.split("-").map(Number);
            const receiveDate = new Date(year, month - 1, day);

            // บวกวันตามค่าใน radioValue (เช่น 60 วัน)
            receiveDate.setDate(
              receiveDate.getDate() + Number(this.radioValue),
            );

            const yyyyEnd = receiveDate.getFullYear();
            const mmEnd = String(receiveDate.getMonth() + 1).padStart(2, "0");
            const ddEnd = String(receiveDate.getDate()).padStart(2, "0");

            this.showaddItem.enddate = `${ddEnd}/${mmEnd}/${yyyyEnd}`;
            this.enddate = `${yyyyEnd}-${mmEnd}-${ddEnd}`;

            // === คำนวณ internaldate (ลบ 1 เดือนจาก enddate) ===
            const [endY, endM, endD] = this.enddate.split("-").map(Number);
            const endDateObj = new Date(endY, endM - 1, endD);

            // คำนวณลบเดือน โดยรักษาวันให้ใกล้ที่สุด (กรณีเดือนวันไม่เท่ากัน)
            const prevMonth = new Date(endY, endM - 1, 0); // วันสุดท้ายของเดือนก่อนหน้า
            const newDay = Math.min(endD, prevMonth.getDate());
            const internalDate = new Date(endY, endM - 2, newDay);

            const yyyyInt = internalDate.getFullYear();
            const mmInt = String(internalDate.getMonth() + 1).padStart(2, "0");
            const ddInt = String(internalDate.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${ddInt}/${mmInt}/${yyyyInt}`;
            this.internaldate = `${yyyyInt}-${mmInt}-${ddInt}`;
          }
        } else {
          if (
            this.data_maserter_pt.date_of_application &&
            this.data_maserter_pt.date_of_application != ""
          ) {
            if (this.radioValue) {
              // แยกปี/เดือน/วันจาก date_of_application
              let [
                year,
                month,
                day,
              ] = this.data_maserter_pt.date_of_application
                .split("-")
                .map(Number);
              let date = new Date(year, month - 1, day);

              // บวกวันจาก radioValue
              date.setDate(date.getDate() + Number(this.radioValue));

              // สร้าง enddate
              const endYear = date.getFullYear();
              const endMonth = String(date.getMonth() + 1).padStart(2, "0");
              const endDay = String(date.getDate()).padStart(2, "0");

              this.showaddItem.enddate = `${endDay}/${endMonth}/${endYear}`; // dd/mm/yyyy
              this.enddate = `${endYear}-${endMonth}-${endDay}`; // yyyy-mm-dd

              // จาก enddate สร้าง internaldate = enddate - 1 เดือน
              date.setMonth(date.getMonth() - 1);

              const intYear = date.getFullYear();
              const intMonth = String(date.getMonth() + 1).padStart(2, "0");
              const intDay = String(date.getDate()).padStart(2, "0");

              this.showaddItem.internaldate = `${intDay}/${intMonth}/${intYear}`;
              this.internaldate = `${intYear}-${intMonth}-${intDay}`;
            }
          } else {
            this.$nextTick(() => {
              this.radioValue = null;
            });
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data",
              `File No. ${this.showaddItem.refno} No Application Date`,
              "text-h5 red--text text-center",
            );
            return;
          }
        }
      } else if (
        this.showaddItem.doctype == 702 ||
        this.showaddItem.doctype == 801
      ) {
        if (this.receive_date && this.radioValue) {
          // === คำนวณ enddate (บวกวัน) ===
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const receiveDate = new Date(year, month - 1, day);

          // บวกวันตามค่าใน radioValue (เช่น 60 วัน)
          receiveDate.setDate(receiveDate.getDate() + Number(this.radioValue));

          const yyyyEnd = receiveDate.getFullYear();
          const mmEnd = String(receiveDate.getMonth() + 1).padStart(2, "0");
          const ddEnd = String(receiveDate.getDate()).padStart(2, "0");

          this.showaddItem.enddate = `${ddEnd}/${mmEnd}/${yyyyEnd}`;
          this.enddate = `${yyyyEnd}-${mmEnd}-${ddEnd}`;

          // === คำนวณ internaldate (ลบ 1 เดือนจาก enddate) ===
          const [endY, endM, endD] = this.enddate.split("-").map(Number);
          const endDateObj = new Date(endY, endM - 1, endD);

          // คำนวณลบเดือน โดยรักษาวันให้ใกล้ที่สุด (กรณีเดือนวันไม่เท่ากัน)
          const prevMonth = new Date(endY, endM - 1, 0); // วันสุดท้ายของเดือนก่อนหน้า
          const newDay = Math.min(endD, prevMonth.getDate());
          const internalDate = new Date(endY, endM - 2, newDay);

          const yyyyInt = internalDate.getFullYear();
          const mmInt = String(internalDate.getMonth() + 1).padStart(2, "0");
          const ddInt = String(internalDate.getDate()).padStart(2, "0");

          this.showaddItem.internaldate = `${ddInt}/${mmInt}/${yyyyInt}`;
          this.internaldate = `${yyyyInt}-${mmInt}-${ddInt}`;
        }
      } else {
        if (
          this.data_maserter_pt.date_of_application &&
          this.data_maserter_pt.date_of_application != ""
        ) {
          if (this.enddate && this.radioValue) {
            // แยกปี/เดือน/วันจาก date_of_application
            let [
              year,
              month,
              day,
            ] = this.data_maserter_pt.date_of_application
              .split("-")
              .map(Number);
            let date = new Date(year, month - 1, day);

            // บวกวันจาก radioValue
            date.setDate(date.getDate() + Number(this.radioValue));

            // สร้าง enddate
            const endYear = date.getFullYear();
            const endMonth = String(date.getMonth() + 1).padStart(2, "0");
            const endDay = String(date.getDate()).padStart(2, "0");

            this.showaddItem.enddate = `${endDay}/${endMonth}/${endYear}`; // dd/mm/yyyy
            this.enddate = `${endYear}-${endMonth}-${endDay}`; // yyyy-mm-dd

            // จาก enddate สร้าง internaldate = enddate - 1 เดือน
            date.setMonth(date.getMonth() - 1);

            const intYear = date.getFullYear();
            const intMonth = String(date.getMonth() + 1).padStart(2, "0");
            const intDay = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${intDay}/${intMonth}/${intYear}`;
            this.internaldate = `${intYear}-${intMonth}-${intDay}`;
          } else {
            this.$nextTick(() => {
              this.radioValue = null;
            });

            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data",
              "Put Final Deadline",
              "text-h5 red--text text-center",
            );
            return;
          }
        } else {
          this.$nextTick(() => {
            this.radioValue = null;
          });
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data",
            `File No. ${this.showaddItem.refno} No Application Date`,
            "text-h5 red--text text-center",
          );
          return;
        }
      }
    },
    onDateSelected() {
      if (this.showaddItem.doctype != 0) {
        if (
          this.showaddItem.doctype == 2 ||
          this.showaddItem.doctype == 111 ||
          this.showaddItem.doctype == 1002
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 1 เดือน
            date.setMonth(date.getMonth() - 1);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0"); // เดือน +1 เพราะ Date ใช้ 0-index
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
              this.radioDateSelect = null;
              this.radioValueDisable = true;
            });
          }
        } else if (
          this.showaddItem.doctype == 4 ||
          this.showaddItem.doctype == 105 ||
          this.showaddItem.doctype == 1007
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 45 วัน
            date.setDate(date.getDate() - 45);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
            });
          }
        } else if (
          this.showaddItem.doctype == 5 ||
          this.showaddItem.doctype == 115 ||
          this.showaddItem.doctype == 1003
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 45 วัน
            date.setDate(date.getDate() - 30);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
            });
          }
        } else if (
          this.showaddItem.doctype == 6 ||
          this.showaddItem.doctype == 108 ||
          this.showaddItem.doctype == 1009
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 45 วัน
            date.setDate(date.getDate() - 30);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
            });
          }
        } else if (
          this.showaddItem.doctype == 9 ||
          this.showaddItem.doctype == 110 ||
          this.showaddItem.doctype == 1005
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 1 เดือน
            date.setMonth(date.getMonth() - 1);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0"); // เดือน +1 เพราะ Date ใช้ 0-index
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
            });
          }
        } else if (
          this.showaddItem.doctype == 10 ||
          this.showaddItem.doctype == 104 ||
          this.showaddItem.doctype == 1011
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 45 วัน
            date.setDate(date.getDate() - 45);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
            });
          }
        } else if (
          this.showaddItem.doctype == 19 ||
          this.showaddItem.doctype == 113 ||
          this.showaddItem.doctype == 1006
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 1 เดือน
            date.setMonth(date.getMonth() - 1);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0"); // เดือน +1 เพราะ Date ใช้ 0-index
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
            });
          }
        } else if (
          this.showaddItem.doctype == 701 ||
          this.showaddItem.doctype == 702 ||
          this.showaddItem.doctype == 801 ||
          this.showaddItem.doctype == 802
        ) {
          if (this.enddate) {
            const [year, month, day] = this.enddate.split("-").map(Number);
            const date = new Date(year, month - 1, day);

            // ลบ 1 เดือน
            date.setMonth(date.getMonth() - 1);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0"); // เดือน +1 เพราะ Date ใช้ 0-index
            const dd = String(date.getDate()).padStart(2, "0");

            this.showaddItem.internaldate = `${dd}/${mm}/${yyyy}`;
            this.internaldate = `${yyyy}-${mm}-${dd}`;

            this.$nextTick(() => {
              this.radioValue = null;
              if (
                this.showaddItem.doctype == 701 ||
                this.showaddItem.doctype == 802
              ) {
                this.radioDateSelect = null;
                this.radioValueDisable = true;
              }
            });
          }
        }
      }
    },
    triggerUpload(index) {
      // ใช้ refs แบบ array
      const input = this.$refs.fileInputs[index];
      if (input) input.click();
    },

    removeFileBox(boxIndex, fileIndex) {
      this.decisionBoxes[boxIndex].files.splice(fileIndex, 1);
    },
    addBox(index) {
      this.decisionBoxes.push({
        files: [],
        date: "",
        menuReceiveBox: false,
        result: "",
        level: index + 2,
      });
    },
    removeBox(index) {
      this.decisionBoxes.splice(index, 1);
    },
    // --- ฟังก์ชัน sanitize ชื่อไฟล์ ---
    sanitizeFileName(fileName) {
      const dotIndex = fileName.lastIndexOf(".");
      const baseName =
        dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName;
      const extension = dotIndex !== -1 ? fileName.substring(dotIndex) : "";

      const sanitizedBase = baseName.replace(/[^a-zA-Z0-9-_ก-ฮะ-์]/g, "_");
      return sanitizedBase + extension;
    },

    // --- ฟังก์ชันตรวจสอบชื่อซ้ำและต่อเลข ---
    getUniqueFileName(file) {
      let name = this.sanitizeFileName(file.name);
      let base = name;
      let counter = 1;

      while (this.dataFileAll.includes(name)) {
        const dotIndex = base.lastIndexOf(".");
        const baseName = dotIndex !== -1 ? base.substring(0, dotIndex) : base;
        const ext = dotIndex !== -1 ? base.substring(dotIndex) : "";
        name = `${baseName}-${counter}${ext}`;
        counter++;
      }

      this.dataFileAll.push(name);
      const newFile = new File([file], name, { type: file.type });
      return newFile;
    },

    // --- ฟังก์ชัน preview notice ---
    async previewMultiFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listnotice.push(result);
        this.preview_listnotice.push(result);

        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image"
        ) {
          this.image_listnotice.push(file);
          this.filenamenotice.push(file.name);
        }
      }

      this.preview_listnotice2 = this.preview_listnotice;
      this.checkfilenotice = true;
      input.value = "";
    },

    // --- ฟังก์ชัน preview attach ---
    async previewMultiAttachFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listattach.push(result);
        this.preview_listattach.push(result);

        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image"
        ) {
          this.image_listattach.push(file);
          this.filenameattach.push(file.name);
        }
      }

      this.preview_listattach2 = this.preview_listattach;
      this.checkfileattach = true;
      input.value = "";
    },

    // --- ฟังก์ชัน preview receipt ---
    async previewMultiReceipt(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listreceipt.push(result);
        this.preview_listrecicpt.push(result);

        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image"
        ) {
          this.image_listrecicpt.push(file);
          this.filenamerecive.push(file.name);
        }
      }

      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.checkfileattach = true;
      input.value = "";
    },

    // --- ฟังก์ชัน upload CSV ---
    async uploadCSVFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      const newFiles = [];

      for (let rawFile of files) {
        if (!rawFile.name.toLowerCase().endsWith(".csv")) continue;

        const file = this.getUniqueFileName
          ? this.getUniqueFileName(rawFile)
          : rawFile;
        newFiles.push(file);
      }

      // แทนที่ไฟล์เก่าด้วยไฟล์ใหม่ทั้งหมด
      this.fileList_good_service = newFiles;

      // reset input เพื่อให้เลือกไฟล์ซ้ำได้
      input.value = "";
    },
    onFilesSelected(index, event) {
      const input = event.target;
      if (!input || !input.files || input.files.length === 0) return;

      const rawFiles = Array.from(input.files);

      // ให้แน่ใจว่า decisionBoxes[index].files และ .previews มีอยู่ (reactive)
      if (!this.decisionBoxes[index]) {
        console.warn("no decisionBoxes entry for index", index);
        return;
      }
      if (!this.decisionBoxes[index].files) {
        this.$set(this.decisionBoxes[index], "files", []);
      }
      if (!this.decisionBoxes[index].previews) {
        this.$set(this.decisionBoxes[index], "previews", []);
      }

      for (const rawFile of rawFiles) {
        // เฉพาะ PDF เท่านั้น (เช็กทั้ง mime type และนามสกุล)
        const isPdf =
          rawFile.type === "application/pdf" ||
          rawFile.name.toLowerCase().endsWith(".pdf");
        if (!isPdf) {
          console.warn("skip non-pdf file:", rawFile.name);
          continue;
        }

        // ใช้ฟังก์ชันของคุณในการ sanitize + กันชื่อซ้ำ
        // getUniqueFileName(file) ตามที่คุณมี จะคืนเป็น File ใหม่ และ push ชื่อเข้า this.dataFileAll
        const file =
          typeof this.getUniqueFileName === "function"
            ? this.getUniqueFileName(rawFile)
            : new File([rawFile], rawFile.name, { type: rawFile.type }); // fallback

        // เก็บไฟล์ลงใน box
        this.decisionBoxes[index].files.push(file);

        // สร้าง preview (ถ้าต้องการแสดง thumbnail / viewer)
        const reader = new FileReader();
        reader.onload = (e) => {
          this.decisionBoxes[index].previews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }

      // รีเซ็ต input เพื่อเปิดให้เลือกไฟล์เดิมได้อีกครั้ง
      input.value = "";
    },
    resetFileState() {
      // --- notice ---
      this.getpreview_listnotice = [];
      this.preview_listnotice = [];
      this.preview_listnotice2 = [];
      this.image_listnotice = [];
      this.filenamenotice = [];
      this.checkfilenotice = false;

      // --- attach ---
      this.getpreview_listattach = [];
      this.preview_listattach = [];
      this.preview_listattach2 = [];
      this.image_listattach = [];
      this.filenameattach = [];
      this.checkfileattach = false;

      // --- receipt ---
      this.getpreview_listreceipt = [];
      this.preview_listrecicpt = [];
      this.preview_listrecipt2 = [];
      this.image_listrecicpt = [];
      this.filenamerecive = [];
      this.checkfileattach = false;

      // --- csv ---
      this.fileList_good_service = [];

      // --- กันชื่อซ้ำ ---
      this.dataFileAll = [];

      // --- uploadedFiles (ใช้กับ handleFileUpload) ---
      this.uploadedFiles = {};

      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
      this.dialogCheckbox = false;
    },
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.widthbtnnoticefile {
  width: 100%;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

h3 {
  font-size: 1.17em;
}

.heightsizesearch {
  height: 45%;
}

.theme--light.v-divider {
  border-color: rgba(0, 0, 0, 1);
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}

.file-link {
  cursor: pointer;
  color: blue;
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}

.mth {
  margin-top: -20px;
}

.custom-autocomplete .v-field__input {
  white-space: normal !important;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 4px;
}

.radio-label >>> .v-label {
  font-size: 14px;
  /* ปรับขนาดตัวอักษร */
}

.decision-box {
  border: 1px solid #d1d5db;
  /* ขอบเทาอ่อน */
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  margin-bottom: 12px;
}

.box-title {
  font-size: 14px;
  font-weight: 600;
}

.box-label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  display: block;
}

.upload-btn {
  height: 40px;
  font-weight: bold;
}

.hidden-input {
  display: none;
}

.decision-box {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
}

.vertical-line {
  border-left: 2px solid #828282;
  /* เส้นแนวตั้งสีเทา */
  height: 100%;
  /* ให้สูงเต็ม container */
}

.sec-title {
  font-size: 0.9rem;
  font-weight: 700;
  padding: 10px 16px 6px;
}

.sec-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #1b7a99;
  font-weight: 700;
  margin-bottom: 14px;
}

.sec-label .hint {
  color: #6b7785;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}

.invoice-box {
  background: #f7fafc;
  border: 1px solid #d8e6f0;
  border-radius: 8px;
  padding: 16px;
}

.field-label {
  font-size: 12.5px;
  color: #37424f;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 18px;
}

.field-label .hint {
  font-size: 11px;
  color: #6b7785;
}

.field-label .hint.danger {
  color: #c0392b;
}

.field-label .req {
  color: #c0392b;
}

.info-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #c47f00;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: help;
}

.is-locked {
  background-color: #b8e6e2 !important;
  border-color: #b8e6e2 !important;
  color: whitesmoke !important;
  opacity: 1 !important;
  pointer-events: none !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

.outstanding-card {
  border-radius: 14px !important;
}

.outstanding-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 28px 8px;
}

.outstanding-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f8e3c2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.outstanding-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1d2b4f;
}

.outstanding-body {
  padding: 8px 28px 20px;
}

.outstanding-text {
  font-size: 1rem;
  color: #2d3748;
  margin-bottom: 14px;
}

.outstanding-box {
  display: flex;
  align-items: center;
  gap: 20px;
  background: #fdf3e6;
  border-radius: 10px;
  padding: 16px 24px;
  margin-bottom: 10px;
}

.outstanding-col {
  display: flex;
  flex-direction: column;
}

.outstanding-label {
  font-size: 0.95rem;
  color: #4a5568;
}

.outstanding-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1d2b4f;
}

.outstanding-divider {
  width: 1px;
  align-self: stretch;
  background: #e2d3bf;
}

.outstanding-chip {
  background: #f6d9a8;
  color: #8a5a12;
  border-radius: 999px;
  padding: 6px 18px;
  font-size: 0.95rem;
  font-weight: 600;
  white-space: nowrap;
}

.outstanding-hint {
  font-size: 0.95rem;
  color: #6b7785;
  margin: 10px 0 0;
}

.outstanding-actions {
  display: flex;
  gap: 16px;
  padding: 20px 28px 24px;
}

.btn-back {
  border-color: #1d2b4f !important;
  color: #1d2b4f !important;
  text-transform: none !important;
  border-radius: 8px !important;
  min-width: 170px !important;
}

.btn-continue {
  text-transform: none !important;
  border-radius: 8px !important;
  min-width: 190px !important;
}

.outstanding-separator {
  height: 1px;
  background: #e5e7eb;
}
</style>
